import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8 text-center text-gray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_3 = { class: "p-5 rounded-2xl bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-900/60 dark:to-gray-800/60 border border-gray-200 dark:border-gray-700 flex flex-col md:flex-row md:items-center md:justify-between gap-4" }
const _hoisted_4 = { class: "flex items-start sm:items-center space-x-4" }
const _hoisted_5 = { class: "w-14 h-14 rounded-2xl bg-secondary text-white flex items-center justify-center text-xl font-black shadow-md flex-shrink-0" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-x-2 gap-y-1.5" }
const _hoisted_7 = { class: "text-xl font-bold text-gray-900 dark:text-white" }
const _hoisted_8 = {
  key: 0,
  class: "px-2.5 py-0.5 rounded-full text-xs font-bold bg-purple-100 text-purple-800 dark:bg-purple-900/60 dark:text-purple-300 inline-flex items-center gap-1.5"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 2,
  class: "px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-300 flex items-center space-x-1"
}
const _hoisted_11 = {
  key: 3,
  class: "px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300 flex items-center space-x-1"
}
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "text-sm text-gray-600 dark:text-gray-300 mt-0.5" }
const _hoisted_14 = { class: "font-semibold text-secondary dark:text-secondary-dark-text" }
const _hoisted_15 = { class: "flex shrink-0 items-center space-x-2 self-end md:self-center flex-wrap gap-y-2" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "truncate" }
const _hoisted_18 = {
  key: 0,
  class: "px-1.5 py-0.2 rounded-full text-[10px] bg-secondary/10 text-secondary dark:text-secondary-dark-text font-bold"
}
const _hoisted_19 = {
  key: 1,
  class: "px-1 py-0.2 rounded text-[9px] bg-secondary/10 text-secondary dark:text-secondary-dark-text font-extrabold uppercase"
}
const _hoisted_20 = { class: "space-y-6" }
const _hoisted_21 = { class: "p-4 rounded-2xl bg-purple-50 dark:bg-purple-950/30 border border-purple-200 dark:border-purple-800/50 flex items-start space-x-3" }
const _hoisted_22 = { class: "p-2 rounded-xl bg-purple-100 dark:bg-purple-900/50 text-purple-700 dark:text-purple-300 flex-shrink-0" }
const _hoisted_23 = { class: "text-xs text-purple-700 dark:text-purple-300 mt-0.5" }
const _hoisted_24 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_25 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_26 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm" }
const _hoisted_27 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_28 = { class: "font-bold text-gray-900 dark:text-white break-all" }
const _hoisted_29 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_30 = { class: "sm:col-span-2" }
const _hoisted_31 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_32 = { class: "font-bold text-purple-700 dark:text-purple-300 flex items-center space-x-1.5" }
const _hoisted_33 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_34 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_35 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm" }
const _hoisted_36 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_37 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_38 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-3" }
const _hoisted_39 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_40 = {
  key: 0,
  class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800"
}
const _hoisted_41 = { class: "text-xs sm:text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap leading-relaxed" }
const _hoisted_42 = {
  key: 1,
  class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 text-xs text-gray-400 italic"
}
const _hoisted_43 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-3" }
const _hoisted_44 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_45 = {
  key: 0,
  class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800"
}
const _hoisted_46 = { class: "text-xs sm:text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap leading-relaxed" }
const _hoisted_47 = {
  key: 1,
  class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 text-xs text-gray-400 italic"
}
const _hoisted_48 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_49 = { class: "flex items-center justify-between" }
const _hoisted_50 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_51 = {
  key: 0,
  class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 text-xs text-gray-400 italic"
}
const _hoisted_52 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-3"
}
const _hoisted_53 = { class: "flex items-center space-x-2.5 min-w-0 flex-1" }
const _hoisted_54 = { class: "p-2 rounded-lg bg-secondary/10 text-secondary dark:text-secondary-dark-text flex-shrink-0" }
const _hoisted_55 = { class: "min-w-0 flex-1" }
const _hoisted_56 = { class: "font-bold text-xs text-gray-900 dark:text-white truncate" }
const _hoisted_57 = { class: "text-[10px] text-gray-500 capitalize" }
const _hoisted_58 = { class: "flex items-center space-x-1 flex-shrink-0" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_62 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_63 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm" }
const _hoisted_64 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_65 = { class: "font-bold text-gray-900 dark:text-white break-all" }
const _hoisted_66 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_67 = { class: "sm:col-span-2" }
const _hoisted_68 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_69 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_70 = { class: "font-bold text-gray-900 dark:text-white flex items-center space-x-2" }
const _hoisted_71 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_72 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_73 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_74 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_75 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 text-sm" }
const _hoisted_76 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_77 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_78 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_79 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_80 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 space-y-2" }
const _hoisted_81 = { class: "flex items-center justify-between text-xs" }
const _hoisted_82 = {
  key: 0,
  class: "text-xs font-semibold text-secondary dark:text-secondary-dark-text bg-secondary/10 px-2 py-0.5 rounded-full"
}
const _hoisted_83 = { class: "grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-2 text-xs" }
const _hoisted_84 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_85 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_86 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_87 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_88 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_89 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_90 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_91 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_92 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_93 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_94 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_95 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_96 = { class: "p-2 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-center" }
const _hoisted_97 = { class: "font-semibold text-gray-800 dark:text-gray-200 text-[11px]" }
const _hoisted_98 = { class: "text-xs text-gray-500 flex items-center gap-4 pt-1" }
const _hoisted_99 = { class: "text-gray-800 dark:text-gray-200" }
const _hoisted_100 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-3" }
const _hoisted_101 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_102 = { class: "overflow-x-auto" }
const _hoisted_103 = { class: "w-full text-xs text-left text-gray-700 dark:text-gray-300" }
const _hoisted_104 = { class: "divide-y divide-gray-100 dark:divide-gray-800" }
const _hoisted_105 = { class: "p-2.5 font-bold" }
const _hoisted_106 = { class: "p-2.5" }
const _hoisted_107 = { class: "p-2.5" }
const _hoisted_108 = { class: "p-2.5" }
const _hoisted_109 = { class: "p-2.5" }
const _hoisted_110 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_111 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_112 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm" }
const _hoisted_113 = {
  key: 0,
  class: "text-xs text-red-600 dark:text-red-400 mt-1"
}
const _hoisted_114 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_115 = { class: "font-bold text-gray-900 dark:text-white" }
const _hoisted_116 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-3" }
const _hoisted_117 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_118 = { class: "flex flex-wrap gap-2 text-xs" }
const _hoisted_119 = {
  key: 0,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_120 = {
  key: 1,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_121 = {
  key: 2,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_122 = {
  key: 3,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_123 = {
  key: 4,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_124 = {
  key: 5,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_125 = {
  key: 6,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_126 = {
  key: 7,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_127 = {
  key: 8,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_128 = {
  key: 9,
  class: "px-2.5 py-1 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 font-semibold border border-blue-200 dark:border-blue-800"
}
const _hoisted_129 = {
  key: 0,
  class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 text-xs"
}
const _hoisted_130 = { class: "text-gray-600 dark:text-gray-400 mt-0.5" }
const _hoisted_131 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_132 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_133 = {
  key: 0,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_134 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_135 = { class: "flex items-center justify-between" }
const _hoisted_136 = { class: "font-bold text-sm text-gray-900 dark:text-white" }
const _hoisted_137 = { class: "text-gray-500" }
const _hoisted_138 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-2 text-gray-600 dark:text-gray-300" }
const _hoisted_139 = {
  key: 0,
  class: "text-gray-600 dark:text-gray-400"
}
const _hoisted_140 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_141 = { class: "flex items-center justify-between flex-wrap gap-2" }
const _hoisted_142 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_143 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_144 = {
  key: 0,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_145 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
}
const _hoisted_146 = { class: "space-y-1.5" }
const _hoisted_147 = { class: "flex items-start justify-between gap-2" }
const _hoisted_148 = { class: "min-w-0 flex-1" }
const _hoisted_149 = { class: "text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500" }
const _hoisted_150 = ["title"]
const _hoisted_151 = { class: "text-gray-600 dark:text-gray-300 font-medium" }
const _hoisted_152 = { class: "pt-2 border-t border-gray-200/60 dark:border-gray-800 space-y-1 text-gray-600 dark:text-gray-400" }
const _hoisted_153 = { class: "flex items-center space-x-1.5 truncate" }
const _hoisted_154 = ["href"]
const _hoisted_155 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_156 = { class: "flex items-center space-x-1.5 truncate" }
const _hoisted_157 = ["href"]
const _hoisted_158 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_159 = {
  key: 0,
  class: "p-2 rounded-lg bg-emerald-100/70 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-800/60 text-[11px] text-emerald-900 dark:text-emerald-200 flex items-start space-x-1.5"
}
const _hoisted_160 = { class: "min-w-0" }
const _hoisted_161 = { class: "font-semibold leading-tight" }
const _hoisted_162 = {
  key: 0,
  class: "text-[10px] text-emerald-700 dark:text-emerald-300 mt-0.5"
}
const _hoisted_163 = {
  key: 1,
  class: "p-2 rounded-lg bg-gray-100/80 dark:bg-gray-800/80 border border-gray-200/80 dark:border-gray-700/80 text-[11px] text-gray-700 dark:text-gray-300 space-y-0.5"
}
const _hoisted_164 = { class: "flex items-center justify-between text-gray-500 dark:text-gray-400 text-[10px] font-semibold uppercase" }
const _hoisted_165 = { class: "flex items-center space-x-1" }
const _hoisted_166 = ["onClick"]
const _hoisted_167 = { class: "whitespace-pre-wrap text-gray-800 dark:text-gray-200 leading-snug" }
const _hoisted_168 = {
  key: 2,
  class: "p-2.5 rounded-xl bg-white dark:bg-gray-800 border border-secondary/40 dark:border-secondary-dark/60 shadow-xs space-y-2"
}
const _hoisted_169 = { class: "flex items-center justify-between" }
const _hoisted_170 = { class: "text-[11px] font-bold text-gray-800 dark:text-gray-200 flex items-center space-x-1" }
const _hoisted_171 = { class: "flex items-center justify-end space-x-1.5" }
const _hoisted_172 = ["disabled", "onClick"]
const _hoisted_173 = { class: "pt-2 border-t border-gray-200/60 dark:border-gray-800 flex items-center justify-between gap-2 flex-wrap" }
const _hoisted_174 = ["disabled", "onClick"]
const _hoisted_175 = ["title", "onClick"]
const _hoisted_176 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_177 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_178 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs" }
const _hoisted_179 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-800 space-y-1" }
const _hoisted_180 = { class: "font-bold text-sm text-gray-900 dark:text-white font-mono" }
const _hoisted_181 = { class: "text-[11px] text-gray-400" }
const _hoisted_182 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-800 space-y-1" }
const _hoisted_183 = { class: "font-bold text-sm text-gray-900 dark:text-white font-mono" }
const _hoisted_184 = { class: "text-[11px] text-gray-400" }
const _hoisted_185 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_186 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_187 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_188 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm" }
const _hoisted_189 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-800" }
const _hoisted_190 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-800" }
const _hoisted_191 = { class: "font-bold text-gray-900 dark:text-white mt-1" }
const _hoisted_192 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-100 dark:border-gray-800" }
const _hoisted_193 = { class: "font-bold text-gray-900 dark:text-white mt-1" }
const _hoisted_194 = {
  key: 1,
  class: "space-y-6"
}
const _hoisted_195 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4 shadow-sm" }
const _hoisted_196 = { class: "flex items-center justify-between border-b border-gray-100 dark:border-gray-700 pb-3" }
const _hoisted_197 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_198 = { class: "space-y-2" }
const _hoisted_199 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-xs" }
const _hoisted_200 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_201 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_202 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_203 = { class: "font-bold text-gray-900 dark:text-white font-mono mt-0.5" }
const _hoisted_204 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_205 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_206 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2" }
const _hoisted_207 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_208 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_209 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_210 = { class: "space-y-2 pt-2 border-t border-gray-100 dark:border-gray-700" }
const _hoisted_211 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 text-xs" }
const _hoisted_212 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_213 = { class: "font-bold text-gray-900 dark:text-white mt-0.5 text-sm" }
const _hoisted_214 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_215 = { class: "font-bold text-gray-900 dark:text-white mt-0.5 text-sm" }
const _hoisted_216 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_217 = { key: 0 }
const _hoisted_218 = { key: 1 }
const _hoisted_219 = { key: 2 }
const _hoisted_220 = { key: 3 }
const _hoisted_221 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_222 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_223 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs" }
const _hoisted_224 = { class: "text-gray-900 dark:text-white font-mono ml-1.5 text-sm" }
const _hoisted_225 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_226 = { class: "text-gray-800 dark:text-gray-200" }
const _hoisted_227 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4 shadow-sm" }
const _hoisted_228 = { class: "flex items-center justify-between border-b border-gray-100 dark:border-gray-700 pb-3" }
const _hoisted_229 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_230 = { class: "space-y-2" }
const _hoisted_231 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 text-xs" }
const _hoisted_232 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_233 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_234 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_235 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_236 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_237 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_238 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_239 = { class: "font-bold text-gray-900 dark:text-white font-mono mt-0.5" }
const _hoisted_240 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2" }
const _hoisted_241 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_242 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_243 = { class: "font-bold text-gray-900 dark:text-white mt-0.5 truncate" }
const _hoisted_244 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_245 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_246 = { class: "space-y-2 pt-2 border-t border-gray-100 dark:border-gray-700" }
const _hoisted_247 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-xs" }
const _hoisted_248 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_249 = { class: "font-bold text-gray-900 dark:text-white mt-0.5 capitalize" }
const _hoisted_250 = { key: 0 }
const _hoisted_251 = { key: 1 }
const _hoisted_252 = { key: 2 }
const _hoisted_253 = { key: 3 }
const _hoisted_254 = { key: 4 }
const _hoisted_255 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_256 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_257 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_258 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_259 = {
  key: 0,
  class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2"
}
const _hoisted_260 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_261 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs" }
const _hoisted_262 = { class: "text-gray-900 dark:text-white font-mono ml-1.5 text-sm" }
const _hoisted_263 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_264 = { class: "text-gray-800 dark:text-gray-200" }
const _hoisted_265 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4 shadow-sm" }
const _hoisted_266 = { class: "flex items-center justify-between border-b border-gray-100 dark:border-gray-700 pb-3" }
const _hoisted_267 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_268 = { class: "space-y-2" }
const _hoisted_269 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 text-xs" }
const _hoisted_270 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2" }
const _hoisted_271 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_272 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_273 = { class: "font-bold text-gray-900 dark:text-white font-mono mt-0.5" }
const _hoisted_274 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_275 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_276 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2" }
const _hoisted_277 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_278 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 sm:col-span-2" }
const _hoisted_279 = { class: "space-y-2 pt-2 border-t border-gray-100 dark:border-gray-700" }
const _hoisted_280 = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-xs" }
const _hoisted_281 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_282 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_283 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_284 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_285 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_286 = { class: "font-bold text-emerald-600 dark:text-emerald-400 mt-0.5 text-sm" }
const _hoisted_287 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_288 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_289 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_290 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_291 = { class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800" }
const _hoisted_292 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_293 = { class: "p-3.5 rounded-xl bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-xs" }
const _hoisted_294 = { class: "text-gray-900 dark:text-white font-mono ml-1.5 text-sm" }
const _hoisted_295 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_296 = { class: "text-gray-800 dark:text-gray-200" }
const _hoisted_297 = { class: "space-y-4" }
const _hoisted_298 = { class: "p-5 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-4" }
const _hoisted_299 = { class: "flex items-center justify-between flex-wrap gap-2" }
const _hoisted_300 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_301 = {
  key: 0,
  class: "p-8 text-center text-sm text-gray-400"
}
const _hoisted_302 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
}
const _hoisted_303 = { class: "flex items-center space-x-3 min-w-0 flex-1" }
const _hoisted_304 = { class: "p-2.5 rounded-xl bg-secondary/10 text-secondary dark:text-secondary-dark-text flex-shrink-0" }
const _hoisted_305 = { class: "min-w-0 flex-1" }
const _hoisted_306 = { class: "font-bold text-xs sm:text-sm text-gray-900 dark:text-white truncate" }
const _hoisted_307 = { class: "flex items-center space-x-2 text-[11px] text-gray-500 mt-0.5 flex-wrap gap-y-1" }
const _hoisted_308 = { class: "capitalize px-1.5 py-0.2 rounded bg-gray-200 dark:bg-gray-700 font-semibold text-[10px]" }
const _hoisted_309 = {
  key: 0,
  class: "px-1.5 py-0.2 rounded text-[10px] font-semibold bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 border border-amber-200/80 dark:border-amber-800/50"
}
const _hoisted_310 = { class: "flex items-center space-x-1.5 flex-shrink-0" }
const _hoisted_311 = ["onClick"]
const _hoisted_312 = ["onClick"]
const _hoisted_313 = { class: "space-y-5" }
const _hoisted_314 = { class: "p-6 rounded-2xl bg-white dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 space-y-6" }
const _hoisted_315 = { class: "flex items-center justify-between border-b border-gray-100 dark:border-gray-700/80 pb-4" }
const _hoisted_316 = { class: "text-sm font-bold text-gray-900 dark:text-white uppercase tracking-wider flex items-center space-x-2" }
const _hoisted_317 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_318 = { class: "p-4 rounded-2xl bg-gray-50/80 dark:bg-gray-900/50 border border-gray-200/70 dark:border-gray-700/60 flex flex-col justify-between space-y-2" }
const _hoisted_319 = { class: "p-4 rounded-2xl bg-gray-50/80 dark:bg-gray-900/50 border border-gray-200/70 dark:border-gray-700/60 flex flex-col justify-between space-y-1" }
const _hoisted_320 = { class: "font-bold text-sm text-gray-900 dark:text-white truncate" }
const _hoisted_321 = { class: "p-4 rounded-2xl bg-gray-50/80 dark:bg-gray-900/50 border border-gray-200/70 dark:border-gray-700/60 flex flex-col justify-between space-y-1" }
const _hoisted_322 = { class: "font-bold text-sm text-gray-900 dark:text-white" }
const _hoisted_323 = { class: "p-5 rounded-2xl bg-gray-50/80 dark:bg-gray-900/50 border border-gray-200/70 dark:border-gray-700/60 space-y-2" }
const _hoisted_324 = { class: "flex items-center space-x-2 text-xs font-bold text-gray-700 dark:text-gray-300" }
const _hoisted_325 = {
  key: 0,
  class: "p-4 rounded-xl bg-white dark:bg-gray-800 border border-gray-200/80 dark:border-gray-700 text-sm text-gray-800 dark:text-gray-200 whitespace-pre-wrap leading-relaxed shadow-sm"
}
const _hoisted_326 = {
  key: 1,
  class: "p-6 rounded-xl bg-white/60 dark:bg-gray-800/40 border border-dashed border-gray-200 dark:border-gray-700 text-center text-xs text-gray-400"
}
const _hoisted_327 = { class: "flex items-center justify-between" }
const _hoisted_328 = { class: "flex items-center space-x-2" }
const _hoisted_329 = {
  key: 0,
  class: "text-xs text-emerald-900 dark:text-emerald-200 space-y-1"
}
const _hoisted_330 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-2 pt-1 font-mono text-[11px]" }
const _hoisted_331 = {
  key: 1,
  class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-amber-900 dark:text-amber-200"
}
const _hoisted_332 = {
  key: 1,
  class: "p-5 rounded-2xl bg-gray-50/80 dark:bg-gray-900/50 border border-gray-200/70 dark:border-gray-700/60 space-y-4"
}
const _hoisted_333 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-gray-200/70 dark:border-gray-700/60 pb-3" }
const _hoisted_334 = { class: "flex items-center space-x-2 text-xs font-bold text-gray-800 dark:text-gray-200 uppercase tracking-wider" }
const _hoisted_335 = { class: "flex items-center space-x-2" }
const _hoisted_336 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_337 = { class: "p-3 bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700 shadow-sm" }
const _hoisted_338 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_339 = { class: "p-3 bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700 shadow-sm" }
const _hoisted_340 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_341 = { class: "p-3 bg-white dark:bg-gray-800 rounded-xl border border-gray-200/80 dark:border-gray-700 shadow-sm" }
const _hoisted_342 = { class: "font-bold text-gray-900 dark:text-white mt-0.5" }
const _hoisted_343 = { class: "space-y-2" }
const _hoisted_344 = {
  key: 0,
  class: "p-5 rounded-xl bg-white/70 dark:bg-gray-800/50 border border-dashed border-gray-200 dark:border-gray-700 text-center text-xs text-gray-400"
}
const _hoisted_345 = {
  key: 1,
  class: "overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm"
}
const _hoisted_346 = { class: "w-full text-xs text-left" }
const _hoisted_347 = { class: "divide-y divide-gray-100 dark:divide-gray-700/60 text-gray-700 dark:text-gray-300" }
const _hoisted_348 = { class: "p-3 font-medium whitespace-nowrap" }
const _hoisted_349 = { class: "p-3" }
const _hoisted_350 = { class: "flex flex-wrap gap-1" }
const _hoisted_351 = { class: "p-3 font-mono text-[11px] text-gray-500" }
const _hoisted_352 = { class: "space-y-4" }
const _hoisted_353 = { class: "p-4 rounded-2xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3" }
const _hoisted_354 = { class: "flex items-center space-x-2 text-sm text-gray-700 dark:text-gray-300" }
const _hoisted_355 = { class: "flex items-center space-x-2 w-full sm:w-auto justify-end flex-wrap gap-2" }
const _hoisted_356 = ["title"]
const _hoisted_357 = {
  id: "printable-application",
  class: "bg-white text-gray-900 border border-gray-300 rounded-2xl p-6 sm:p-10 shadow-sm space-y-6 max-w-4xl mx-auto printable-area"
}
const _hoisted_358 = { class: "border-b-2 border-secondary pb-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3" }
const _hoisted_359 = { class: "text-xs text-gray-500 font-semibold tracking-wide uppercase mt-0.5" }
const _hoisted_360 = { class: "text-right sm:text-right text-xs text-gray-600" }
const _hoisted_361 = { class: "font-mono font-bold text-sm text-gray-900" }
const _hoisted_362 = { class: "text-[11px] text-gray-500 mt-0.5" }
const _hoisted_363 = { class: "mt-1.5 flex items-center justify-end space-x-1.5" }
const _hoisted_364 = {
  key: 0,
  class: "px-2 py-0.5 rounded text-[10px] font-bold uppercase bg-purple-100 text-purple-800"
}
const _hoisted_365 = { class: "space-y-3" }
const _hoisted_366 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_367 = { class: "font-bold text-sm text-gray-900" }
const _hoisted_368 = { class: "font-bold text-gray-900 break-all" }
const _hoisted_369 = { class: "font-bold text-gray-900" }
const _hoisted_370 = { class: "sm:col-span-2" }
const _hoisted_371 = { class: "font-bold text-gray-900" }
const _hoisted_372 = { class: "space-y-3" }
const _hoisted_373 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs" }
const _hoisted_374 = { class: "font-bold text-gray-900" }
const _hoisted_375 = { class: "font-bold text-gray-900" }
const _hoisted_376 = { class: "space-y-2" }
const _hoisted_377 = { class: "p-3.5 rounded bg-gray-50 border border-gray-200 text-xs" }
const _hoisted_378 = { class: "text-gray-800 whitespace-pre-wrap leading-relaxed" }
const _hoisted_379 = { class: "space-y-2" }
const _hoisted_380 = { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }
const _hoisted_381 = {
  key: 0,
  class: "text-xs text-gray-500 italic p-2 bg-gray-50 rounded border border-gray-200"
}
const _hoisted_382 = {
  key: 1,
  class: "border border-gray-200 rounded-xl overflow-hidden divide-y divide-gray-200 text-xs"
}
const _hoisted_383 = { class: "flex items-center space-x-2 min-w-0" }
const _hoisted_384 = { class: "font-bold text-gray-900 truncate" }
const _hoisted_385 = { class: "text-[10px] uppercase font-semibold px-1.5 py-0.5 rounded bg-gray-100 text-gray-600" }
const _hoisted_386 = { class: "text-gray-400 text-[10px]" }
const _hoisted_387 = {
  key: 0,
  class: "text-right flex-shrink-0"
}
const _hoisted_388 = { class: "text-[10px] font-semibold text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded border border-amber-200" }
const _hoisted_389 = { class: "space-y-2" }
const _hoisted_390 = { class: "p-3 rounded bg-gray-50 border border-gray-200 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_391 = { class: "font-bold mt-0.5" }
const _hoisted_392 = { class: "font-bold mt-0.5 truncate" }
const _hoisted_393 = { class: "font-bold mt-0.5" }
const _hoisted_394 = {
  key: 0,
  class: "sm:col-span-3 pt-2 border-t border-gray-200"
}
const _hoisted_395 = { class: "font-bold text-gray-900 mt-0.5" }
const _hoisted_396 = {
  key: 1,
  class: "sm:col-span-3 pt-2 border-t border-gray-200"
}
const _hoisted_397 = { class: "text-gray-800 text-xs mt-0.5 whitespace-pre-wrap" }
const _hoisted_398 = { class: "space-y-3" }
const _hoisted_399 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_400 = { class: "font-bold text-sm text-gray-900" }
const _hoisted_401 = { class: "font-bold text-gray-900 break-all" }
const _hoisted_402 = { class: "font-bold text-gray-900" }
const _hoisted_403 = { class: "sm:col-span-2" }
const _hoisted_404 = { class: "font-bold text-gray-900" }
const _hoisted_405 = { class: "font-bold text-gray-900" }
const _hoisted_406 = { class: "font-bold text-gray-900 font-mono" }
const _hoisted_407 = { class: "font-bold text-gray-900" }
const _hoisted_408 = { class: "font-bold text-gray-900" }
const _hoisted_409 = { class: "space-y-2" }
const _hoisted_410 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_411 = { class: "font-bold text-gray-900" }
const _hoisted_412 = { class: "font-bold text-gray-900" }
const _hoisted_413 = { class: "font-bold text-gray-900" }
const _hoisted_414 = { class: "font-bold text-gray-900" }
const _hoisted_415 = { class: "font-bold text-gray-900" }
const _hoisted_416 = { class: "font-bold text-gray-900" }
const _hoisted_417 = { class: "p-2 rounded bg-gray-50 border border-gray-200 text-xs" }
const _hoisted_418 = { class: "text-[10px] text-gray-500 uppercase font-semibold block mb-1" }
const _hoisted_419 = { class: "grid grid-cols-7 gap-1 text-[11px] text-center" }
const _hoisted_420 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_421 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_422 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_423 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_424 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_425 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_426 = { class: "p-1 bg-white border border-gray-200 rounded" }
const _hoisted_427 = { class: "space-y-2" }
const _hoisted_428 = { class: "w-full text-xs text-left border border-gray-200" }
const _hoisted_429 = { class: "divide-y divide-gray-200" }
const _hoisted_430 = { class: "p-2 font-bold border-r border-gray-200" }
const _hoisted_431 = { class: "p-2 border-r border-gray-200" }
const _hoisted_432 = { class: "p-2 border-r border-gray-200" }
const _hoisted_433 = { class: "p-2 border-r border-gray-200" }
const _hoisted_434 = { class: "p-2" }
const _hoisted_435 = { class: "space-y-2" }
const _hoisted_436 = { class: "p-2.5 rounded bg-gray-50 border border-gray-200 space-y-1.5 text-xs" }
const _hoisted_437 = { class: "flex flex-wrap gap-1.5 text-[11px]" }
const _hoisted_438 = {
  key: 0,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_439 = {
  key: 1,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_440 = {
  key: 2,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_441 = {
  key: 3,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_442 = {
  key: 4,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_443 = {
  key: 5,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_444 = {
  key: 6,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_445 = {
  key: 7,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_446 = {
  key: 8,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_447 = {
  key: 9,
  class: "px-2 py-0.5 rounded bg-white border border-gray-300 font-semibold"
}
const _hoisted_448 = {
  key: 0,
  class: "text-[11px] text-gray-700 pt-0.5"
}
const _hoisted_449 = { class: "space-y-3" }
const _hoisted_450 = {
  key: 0,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_451 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_452 = { class: "flex justify-between items-center font-bold text-gray-900" }
const _hoisted_453 = { class: "text-gray-500 font-normal" }
const _hoisted_454 = { class: "text-[11px] text-gray-600" }
const _hoisted_455 = {
  key: 0,
  class: "text-[11px] text-gray-600 pt-0.5"
}
const _hoisted_456 = { class: "space-y-2" }
const _hoisted_457 = { class: "flex items-center justify-between border-b border-gray-200 pb-1" }
const _hoisted_458 = {
  key: 0,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_459 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-3 gap-2"
}
const _hoisted_460 = { class: "flex items-center justify-between" }
const _hoisted_461 = { class: "font-bold text-gray-900 block truncate" }
const _hoisted_462 = { class: "text-[11px] text-gray-600" }
const _hoisted_463 = { class: "text-[10px] text-gray-500" }
const _hoisted_464 = {
  key: 0,
  class: "text-[9.5px] text-emerald-800 font-medium"
}
const _hoisted_465 = {
  key: 1,
  class: "text-[9.5px] text-gray-600 italic"
}
const _hoisted_466 = { class: "space-y-2" }
const _hoisted_467 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-3 text-xs" }
const _hoisted_468 = { class: "p-2.5 rounded bg-gray-50 border border-gray-200" }
const _hoisted_469 = { class: "font-bold text-gray-900 mt-0.5" }
const _hoisted_470 = { class: "text-[10px] text-gray-500 mt-0.5" }
const _hoisted_471 = { class: "p-2.5 rounded bg-gray-50 border border-gray-200" }
const _hoisted_472 = {
  key: 0,
  class: "text-[10px] text-red-500 mt-0.5"
}
const _hoisted_473 = { class: "p-2.5 rounded bg-gray-50 border border-gray-200" }
const _hoisted_474 = { class: "font-bold text-gray-900 font-mono mt-0.5" }
const _hoisted_475 = { class: "text-[10px] text-gray-500" }
const _hoisted_476 = { class: "p-2.5 rounded bg-gray-50 border border-gray-200" }
const _hoisted_477 = { class: "font-bold text-gray-900 font-mono mt-0.5" }
const _hoisted_478 = { class: "text-[10px] text-gray-500" }
const _hoisted_479 = { class: "space-y-3" }
const _hoisted_480 = { class: "p-2.5 rounded border border-gray-200 bg-gray-50/50 space-y-1.5 text-xs" }
const _hoisted_481 = { class: "flex justify-between items-center font-bold text-gray-900 border-b border-gray-200/80 pb-1" }
const _hoisted_482 = { class: "text-[10px] text-gray-500 font-normal" }
const _hoisted_483 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-2 text-[11px] text-gray-700" }
const _hoisted_484 = { class: "text-[10px] text-gray-500 font-mono block" }
const _hoisted_485 = { class: "sm:col-span-2" }
const _hoisted_486 = { class: "p-2.5 rounded border border-gray-200 bg-gray-50/50 space-y-1.5 text-xs" }
const _hoisted_487 = { class: "flex justify-between items-center font-bold text-gray-900 border-b border-gray-200/80 pb-1" }
const _hoisted_488 = { class: "text-[10px] text-gray-500 font-normal" }
const _hoisted_489 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-2 text-[11px] text-gray-700" }
const _hoisted_490 = { class: "sm:col-span-2" }
const _hoisted_491 = { class: "p-2.5 rounded border border-gray-200 bg-gray-50/50 space-y-1.5 text-xs" }
const _hoisted_492 = { class: "flex justify-between items-center font-bold text-gray-900 border-b border-gray-200/80 pb-1" }
const _hoisted_493 = { class: "text-[10px] text-gray-500 font-normal" }
const _hoisted_494 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-2 text-[11px] text-gray-700" }
const _hoisted_495 = { class: "space-y-2" }
const _hoisted_496 = { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }
const _hoisted_497 = {
  key: 0,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_498 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs"
}
const _hoisted_499 = { class: "truncate mr-2" }
const _hoisted_500 = { class: "font-bold text-gray-900 block truncate" }
const _hoisted_501 = { class: "text-[10px] text-gray-500 capitalize" }
const _hoisted_502 = {
  key: 0,
  class: "text-right flex-shrink-0"
}
const _hoisted_503 = { class: "text-[10px] font-semibold text-amber-700 bg-amber-50 px-1.5 py-0.5 rounded border border-amber-200" }
const _hoisted_504 = { class: "space-y-2" }
const _hoisted_505 = { class: "p-3 rounded bg-gray-50 border border-gray-200 grid grid-cols-1 sm:grid-cols-3 gap-3 text-xs" }
const _hoisted_506 = { class: "font-bold mt-0.5" }
const _hoisted_507 = { class: "font-bold mt-0.5 truncate" }
const _hoisted_508 = { class: "font-bold mt-0.5" }
const _hoisted_509 = {
  key: 0,
  class: "sm:col-span-3 pt-2 border-t border-gray-200"
}
const _hoisted_510 = { class: "text-gray-800 text-xs mt-0.5 whitespace-pre-wrap" }
const _hoisted_511 = { class: "pt-4 border-t border-gray-200 text-center text-[10px] text-gray-400" }
const _hoisted_512 = { class: "flex items-center justify-between w-full" }
const _hoisted_513 = { class: "flex items-center space-x-2.5" }
const _hoisted_514 = { class: "space-y-4" }
const _hoisted_515 = {
  key: 0,
  class: "space-y-2 max-h-60 overflow-y-auto pr-1"
}
const _hoisted_516 = { class: "min-w-0 flex-1" }
const _hoisted_517 = { class: "font-bold text-gray-900 dark:text-white truncate" }
const _hoisted_518 = { class: "text-[11px] text-gray-500" }
const _hoisted_519 = { class: "flex items-center space-x-2" }
const _hoisted_520 = ["onUpdate:modelValue"]
const _hoisted_521 = ["onClick"]
const _hoisted_522 = { class: "flex items-center justify-end space-x-3 w-full" }

import { ref, computed, watch } from 'vue'
import { BaseModal, BaseButton } from '@/components/common'
import PrintConfirmModal from '@/components/modals/PrintConfirmModal.vue'
import ViewApplicationDocumentModal from '@/components/modals/ViewApplicationDocumentModal.vue'
import type { ApplicationDetail, ApplicationDocument, ReferenceEntry } from '@/types/application'
import { applicationService } from '@/services/applicationService'
import { useToastService } from '@/services/toast'
import {
  FileText,
  User,
  ShieldCheck,
  Briefcase,
  Receipt,
  Paperclip,
  History,
  ClipboardCheck,
  Clock,
  GraduationCap,
  Car,
  CheckCircle2,
  Download,
  Printer,
  ExternalLink,
  Cpu,
  Users,
  UserPlus,
  UploadCloud,
  Eye,
  EyeOff,
  Trash2,
  Send,
  KeyRound,
  Check,
  X,
  MessageSquare,
  Phone,
  Mail,
  Edit3,
  Loader2,
} from 'lucide-vue-next'

interface Props {
  isVisible: boolean
  application?: ApplicationDetail | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ViewApplicationDetails',
  props: {
    isVisible: { type: Boolean },
    application: {}
  },
  emits: ["close", "review", "create-account", "delete", "documents-updated", "references-updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const toast = useToastService()

const activeTab = ref('job_application')
const isSsnRevealed = ref(false)
const isPrintSsnMasked = ref(true)
const isPrintConfirmVisible = ref(false)

// Access link action loading state
const isResendingLink = ref(false)
const isRevokingAccess = ref(false)

const handleResendAccessLink = async () => {
  if (!props.application?.application_id) return
  if (!confirm(`Generate and send a new secure edit link to ${props.application.email}?`)) {
    return
  }
  isResendingLink.value = true
  try {
    const res = await applicationService.resendAccessLink(props.application.application_id)
    toast.success(res.message || 'Access link sent successfully to applicant.')
    emit('documents-updated')
  } catch (err: any) {
    toast.error(err.response?.data?.message || err.message || 'Failed to resend access link.')
  } finally {
    isResendingLink.value = false
  }
}

const handleRevokeAccess = async () => {
  if (!props.application?.application_id) return
  if (!confirm(`Revoke active access tokens and edit sessions for Application #${props.application.application_id}? The applicant will no longer be able to log in or edit.`)) {
    return
  }
  isRevokingAccess.value = true
  try {
    const res = await applicationService.revokeAccess(props.application.application_id)
    toast.success(res.message || 'Applicant edit access has been revoked.')
    emit('documents-updated')
  } catch (err: any) {
    toast.error(err.response?.data?.message || err.message || 'Failed to revoke applicant access.')
  } finally {
    isRevokingAccess.value = false
  }
}

// Local documents state synced from props to avoid mutating props
const localDocuments = ref<ApplicationDocument[]>([])

watch(
  () => props.application?.documents,
  (docs) => {
    localDocuments.value = docs ? [...docs] : []
  },
  { immediate: true }
)

// Document preview state
const isPreviewModalVisible = ref(false)
const selectedDocForPreview = ref<ApplicationDocument | null>(null)

// Extra document upload state
const isUploadModalOpen = ref(false)
const isUploadingDocs = ref(false)
const isDragging = ref(false)
const extraFileInputRef = ref<HTMLInputElement | null>(null)
const newUploadFiles = ref<Array<{ file: File; category: string }>>([])

const isPaperRecord = computed(() => props.application?.record_type === 'paper')

const visibleTabs = computed(() => {
  if (isPaperRecord.value) {
    return [
      { id: 'job_application', label: 'Record Details', icon: FileText },
      { id: 'documents', label: 'Attachments', icon: Paperclip },
      { id: 'review_history', label: 'Review Notes', icon: History },
      { id: 'print_pdf', label: 'Print / PDF Preview', icon: Printer },
    ]
  }
  return [
    { id: 'job_application', label: 'Job Application', icon: Briefcase },
    { id: 'background_check', label: 'Background Check', icon: ShieldCheck },
    { id: 'tax_docs', label: 'Tax Documents', icon: Receipt },
    { id: 'documents', label: 'Attachments', icon: Paperclip },
    { id: 'review_history', label: 'Review Notes', icon: History },
    { id: 'print_pdf', label: 'Print / PDF Preview', icon: Printer },
  ]
})

const isPlaceholderEmail = (email?: string | null) => {
  if (!email) return true
  return email.startsWith('paper-record-') && email.endsWith('@jeducare.local')
}

const formatAddress = (app?: ApplicationDetail | null) => {
  if (!app) return ''
  const parts = [
    app.street_address,
    app.city,
    [app.state, app.zip_code].filter(Boolean).join(' ')
  ].filter(Boolean)
  return parts.join(', ')
}

watch(
  () => props.application,
  (newApp) => {
    if (newApp?.record_type === 'paper' && (activeTab.value === 'background_check' || activeTab.value === 'tax_docs')) {
      activeTab.value = 'job_application'
    }
  }
)

const jobApp = computed(() => props.application?.job_application_data)
const taxDocs = computed(() => props.application?.tax_doc_data)

// Local references state to allow reactive updates on verification actions
const localReferences = ref<ReferenceEntry[]>([])
const savingIndex = ref<number | null>(null)
const editingNoteIndex = ref<number | null>(null)
const editingNoteText = ref<string>('')

watch(
  () => props.application?.job_application_data?.references,
  (refs) => {
    localReferences.value = Array.isArray(refs) ? JSON.parse(JSON.stringify(refs)) : []
  },
  { immediate: true, deep: true }
)

const displayReferences = computed<ReferenceEntry[]>(() => {
  if (localReferences.value.length > 0) return localReferences.value
  return (props.application?.job_application_data?.references as ReferenceEntry[]) || []
})

const verifiedReferencesCount = computed(() => {
  return displayReferences.value.filter((r) => !!r.is_verified).length
})

const openEditNotes = (idx: number) => {
  editingNoteIndex.value = idx
  editingNoteText.value = displayReferences.value[idx]?.verification_notes || ''
}

const cancelEditNotes = () => {
  editingNoteIndex.value = null
  editingNoteText.value = ''
}

const saveNotesOnly = async (idx: number) => {
  if (!props.application?.application_id) return
  const currentRef = displayReferences.value[idx]
  if (!currentRef) return

  savingIndex.value = idx
  try {
    const res = await applicationService.updateReferenceVerification(
      props.application.application_id,
      {
        reference_index: idx,
        is_verified: !!currentRef.is_verified,
        verification_notes: editingNoteText.value.trim(),
      }
    )
    if (localReferences.value[idx]) {
      localReferences.value[idx].verification_notes = editingNoteText.value.trim()
    }
    toast.success('Reference notes saved.')
    editingNoteIndex.value = null
    editingNoteText.value = ''
    emit('references-updated', res.data)
    emit('documents-updated')
  } catch (err: any) {
    toast.error(err.response?.data?.message || err.message || 'Failed to save reference notes.')
  } finally {
    savingIndex.value = null
  }
}

const toggleReferenceVerification = async (idx: number) => {
  if (!props.application?.application_id) return
  const currentRef = displayReferences.value[idx]
  if (!currentRef) return

  const nextStatus = !currentRef.is_verified
  const notes = editingNoteIndex.value === idx ? editingNoteText.value.trim() : (currentRef.verification_notes || undefined)

  savingIndex.value = idx
  try {
    const res = await applicationService.updateReferenceVerification(
      props.application.application_id,
      {
        reference_index: idx,
        is_verified: nextStatus,
        verification_notes: notes,
      }
    )
    if (res.reference && localReferences.value[idx]) {
      localReferences.value[idx] = { ...localReferences.value[idx], ...res.reference }
    } else if (localReferences.value[idx]) {
      localReferences.value[idx].is_verified = nextStatus
      if (!nextStatus) {
        localReferences.value[idx].verified_at = null
        localReferences.value[idx].verified_by = null
      }
    }

    toast.success(res.message || (nextStatus ? 'Reference verified successfully.' : 'Reference verification cleared.'))
    if (editingNoteIndex.value === idx) {
      editingNoteIndex.value = null
      editingNoteText.value = ''
    }
    emit('references-updated', res.data)
    emit('documents-updated')
  } catch (err: any) {
    toast.error(err.response?.data?.message || err.message || 'Failed to update reference verification.')
  } finally {
    savingIndex.value = null
  }
}
const applicantSsn = computed(() => {
  return (
    jobApp.value?.social_security_number ||
    taxDocs.value?.mw507?.social_security_number ||
    taxDocs.value?.w4?.social_security_number ||
    taxDocs.value?.i9?.social_security_number ||
    ''
  )
})

const canCreateStaffAccount = (app?: ApplicationDetail | null) => {
  if (!app) return false
  if (app.fk_created_user_id || app.fk_linked_user_id) return false
  return app.application_status === 'approved' || app.record_type === 'paper'
}

const formatStatus = (status?: string) => {
  if (!status) return 'Pending'
  if (status.toLowerCase() === 'reviewed') return 'Under Review'
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
}

const closeModal = () => {
  emit('close')
  activeTab.value = 'job_application'
  isSsnRevealed.value = false
}

const getInitials = (name?: string) => {
  if (!name) return 'AP'
  const parts = name.trim().split(' ')
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

const maskSsn = (ssn?: string) => {
  if (!ssn) return 'N/A'
  const clean = ssn.replace(/\D/g, '')
  if (clean.length === 9) {
    return `***-**-${clean.substring(5)}`
  }
  return '***-**-****'
}

const formatFullSsn = (ssn?: string) => {
  if (!ssn) return ''
  const clean = ssn.replace(/\D/g, '')
  if (clean.length === 9) {
    return `${clean.substring(0, 3)}-${clean.substring(3, 5)}-${clean.substring(5)}`
  }
  if (ssn.includes('*') && clean.length >= 4) {
    return `123-45-${clean.slice(-4)}`
  }
  return ssn
}

const formatDate = (dateStr?: string | null) => {
  if (!dateStr) return 'N/A'
  try {
    return new Date(dateStr).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return dateStr
  }
}

const formatFileSize = (bytes?: number) => {
  if (!bytes) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

const getStatusBadgeClass = (status?: string) => {
  switch (status) {
    case 'approved':
      return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300'
    case 'rejected':
      return 'bg-red-100 text-red-800 dark:bg-red-950/40 dark:text-red-300'
    case 'reviewed':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-950/40 dark:text-blue-300'
    case 'completed':
      return 'bg-purple-100 text-purple-800 dark:bg-purple-950/40 dark:text-purple-300'
    case 'pending':
    default:
      return 'bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300'
  }
}

const handleDownload = async (doc: ApplicationDocument) => {
  if (doc.document_id) {
    await applicationService.downloadDocument(doc.document_id, doc.file_name)
  }
}

const handleOpenPdfNewTab = async () => {
  if (!props.application?.application_id) return

  try {
    const blob = await applicationService.getApplicationPdfBlob(
      props.application.application_id,
      { mask_ssn: isPrintSsnMasked.value ? 1 : 0 }
    )
    const url = window.URL.createObjectURL(blob)
    window.open(url, '_blank')
  } catch (err) {
    console.error('Failed to open PDF in new tab:', err)
  }
}

const handleRequestPrint = () => {
  isPrintConfirmVisible.value = true
}

const handleConfirmPrint = async (options?: { includeRemarks?: boolean; includeSignatures?: boolean; maskSsn?: boolean }) => {
  isPrintConfirmVisible.value = false
  const maskSsnVal = options?.maskSsn !== false
  isPrintSsnMasked.value = maskSsnVal

  if (!props.application?.application_id) return

  const applicationId = props.application.application_id
  const sanitizedName = props.application.full_name?.replace(/[^a-zA-Z0-9_-]/g, '_') || 'Applicant'
  const fileName = `Jeducare_Application_${applicationId}_${sanitizedName}.pdf`
  const previewWindow = window.open('', '_blank')

  try {
    const blob = await applicationService.getApplicationPdfBlob(
      applicationId,
      { mask_ssn: maskSsnVal ? 1 : 0 }
    )
    const previewUrl = window.URL.createObjectURL(blob)

    if (previewWindow) {
      let printTriggered = false
      const printPreview = () => {
        if (printTriggered) return
        printTriggered = true
        previewWindow.focus()
        previewWindow.print()
      }
      previewWindow.onload = () => window.setTimeout(printPreview, 300)
      previewWindow.location.href = previewUrl
      window.setTimeout(printPreview, 1500)
    }

    const link = document.createElement('a')
    link.href = previewUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.setTimeout(() => window.URL.revokeObjectURL(previewUrl), 60000)
  } catch (err: any) {
    previewWindow?.close()
    toast.error(err.response?.data?.message || err.message || 'Failed to print application PDF.')
  }
}

const handlePreview = (doc: ApplicationDocument) => {
  selectedDocForPreview.value = doc
  isPreviewModalVisible.value = true
}

const closeUploadModal = () => {
  isUploadModalOpen.value = false
  newUploadFiles.value = []
  isDragging.value = false
}

const triggerExtraFileInput = () => {
  extraFileInputRef.value?.click()
}

const handleExtraFileInputChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.files?.length) {
    const maxBytes = 32 * 1024 * 1024
    Array.from(target.files).forEach((file) => {
      if (file.size > maxBytes) {
        toast.error(`File "${file.name}" exceeds the 32MB size limit.`)
        return
      }
      newUploadFiles.value.push({ file, category: 'other' })
    })
    target.value = ''
  }
}

const handleExtraFileDrop = (event: DragEvent) => {
  isDragging.value = false
  if (event.dataTransfer?.files?.length) {
    const maxBytes = 32 * 1024 * 1024
    Array.from(event.dataTransfer.files).forEach((file) => {
      if (file.size > maxBytes) {
        toast.error(`File "${file.name}" exceeds the 32MB size limit.`)
        return
      }
      newUploadFiles.value.push({ file, category: 'other' })
    })
  }
}

const handleExecuteUploadDocs = async () => {
  if (!props.application?.application_id || newUploadFiles.value.length === 0) return

  isUploadingDocs.value = true
  try {
    const formData = new FormData()
    newUploadFiles.value.forEach((item, index) => {
      formData.append(`documents[${index}]`, item.file)
      formData.append(`document_categories[${index}]`, item.category)
      formData.append(`document_names[${index}]`, item.file.name)
    })

    const response = await applicationService.uploadDocuments(props.application.application_id, formData)
    toast.success(response.message || 'Documents uploaded successfully.')

    if (response.data && Array.isArray(response.data)) {
      localDocuments.value = response.data
    }

    closeUploadModal()
    emit('documents-updated')
  } catch (err: any) {
    const msg = err.response?.data?.message || err.message || 'Failed to upload documents.'
    toast.error(msg)
  } finally {
    isUploadingDocs.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_vue_loaders = _resolveComponent("vue-loaders")!

  return (_openBlock(), _createBlock(_unref(BaseModal), {
    "is-visible": _ctx.isVisible,
    title: `Application Ref #${_ctx.application?.application_id || ''}`,
    subtitle: _ctx.application ? `Submitted by ${_ctx.application.full_name}` : 'Loading application details...',
    icon: _unref(FileText),
    size: "4xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_512, [
        _createVNode(_unref(BaseButton), {
          variant: "outline",
          size: "md",
          text: "Close",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_513, [
          (canCreateStaffAccount(_ctx.application))
            ? (_openBlock(), _createBlock(_unref(BaseButton), {
                key: 0,
                variant: "success",
                size: "md",
                text: "Create Staff",
                icon: _unref(UserPlus),
                "icon-position": "left",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('create-account', _ctx.application)))
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(BaseButton), {
            variant: "primary",
            size: "md",
            text: "Review Application",
            icon: _unref(ClipboardCheck),
            "icon-position": "left",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('review', _ctx.application)))
          }, null, 8, ["icon"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.application)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_vue_loaders, {
              name: "line-scale",
              color: "#035fa3",
              scale: "1.2",
              class: "mb-3"
            }),
            _cache[17] || (_cache[17] = _createElementVNode("p", null, "Loading application details...", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(getInitials(_ctx.application.full_name)), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.application.full_name), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["px-2.5 py-0.5 rounded-full text-xs font-bold", getStatusBadgeClass(_ctx.application.application_status)])
                    }, _toDisplayString(formatStatus(_ctx.application.application_status)), 3),
                    (_ctx.application.record_type === 'paper')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          _createVNode(_unref(FileText), { class: "w-3.5 h-3.5 text-purple-700 dark:text-purple-300" }),
                          _cache[18] || (_cache[18] = _createElementVNode("span", null, "Paper Record (Digitized)", -1))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.application.fk_linked_user_id && _ctx.application.fk_linked_user_id !== _ctx.application.fk_created_user_id)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-indigo-100 text-indigo-800 dark:bg-indigo-900/60 dark:text-indigo-300 flex items-center space-x-1",
                          title: `Linked to Staff Member User #${_ctx.application.fk_linked_user_id}`
                        }, [
                          _createVNode(_unref(Users), { class: "w-3 h-3 text-indigo-600 dark:text-indigo-400" }),
                          _createElementVNode("span", null, "Linked Staff #" + _toDisplayString(_ctx.application.fk_linked_user_id), 1)
                        ], 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (_ctx.application.fk_created_user_id || (_ctx.application.fk_linked_user_id && _ctx.application.fk_linked_user_id === _ctx.application.fk_created_user_id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_unref(CheckCircle2), { class: "w-3 h-3 text-emerald-600 dark:text-emerald-400" }),
                          _createElementVNode("span", null, "Staff Account Active (#" + _toDisplayString(_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id) + ")", 1)
                        ]))
                      : (canCreateStaffAccount(_ctx.application))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                            _createVNode(_unref(Clock), { class: "w-3 h-3 text-amber-600 dark:text-amber-400" }),
                            _cache[19] || (_cache[19] = _createElementVNode("span", null, "Staff Account Pending", -1))
                          ]))
                        : _createCommentVNode("", true),
                    (_ctx.application.applicant_edit_count && _ctx.application.applicant_edit_count > 0)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 4,
                          class: "px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-blue-100 text-blue-800 dark:bg-blue-900/60 dark:text-blue-300 inline-flex items-center space-x-1",
                          title: `Edited by applicant ${_ctx.application.applicant_edit_count} time(s). Last edit: ${formatDate(_ctx.application.last_edited_by_applicant_at)}`
                        }, [
                          _createVNode(_unref(History), { class: "w-3 h-3 text-blue-600 dark:text-blue-400" }),
                          _createElementVNode("span", null, "Edited by Applicant (" + _toDisplayString(_ctx.application.applicant_edit_count) + "x)", 1)
                        ], 8, _hoisted_12))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.application.position_applied_for || 'Position Not Specified'), 1),
                    _createTextVNode(" • Submitted on " + _toDisplayString(formatDate(_ctx.application.submitted_at || _ctx.application.created_at)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.application.record_type !== 'paper' && _ctx.application.is_editable_by_applicant)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 0,
                      variant: "outline",
                      size: "md",
                      text: "Resend Edit Link",
                      icon: _unref(Send),
                      "icon-position": "left",
                      loading: isResendingLink.value,
                      class: "whitespace-nowrap",
                      onClick: handleResendAccessLink
                    }, null, 8, ["icon", "loading"]))
                  : _createCommentVNode("", true),
                (_ctx.application.record_type !== 'paper' && _ctx.application.has_active_access_link)
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 1,
                      variant: "outline",
                      size: "md",
                      text: "Revoke Access",
                      icon: _unref(KeyRound),
                      "icon-position": "left",
                      loading: isRevokingAccess.value,
                      class: "whitespace-nowrap text-red-600 hover:text-red-700 border-red-200 hover:bg-red-50 dark:hover:bg-red-950/40",
                      onClick: handleRevokeAccess
                    }, null, 8, ["icon", "loading"]))
                  : _createCommentVNode("", true),
                (canCreateStaffAccount(_ctx.application))
                  ? (_openBlock(), _createBlock(_unref(BaseButton), {
                      key: 2,
                      variant: "success",
                      size: "md",
                      text: "Create Staff",
                      icon: _unref(UserPlus),
                      "icon-position": "left",
                      class: "whitespace-nowrap",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('create-account', _ctx.application)))
                    }, null, 8, ["icon"]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(BaseButton), {
                  variant: "outline",
                  size: "md",
                  text: "Delete",
                  icon: _unref(Trash2),
                  "icon-position": "left",
                  class: "whitespace-nowrap text-red-600 hover:text-red-700 border-red-200 hover:bg-red-50 dark:hover:bg-red-950/40",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', _ctx.application)))
                }, null, 8, ["icon"])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["p-1.5 rounded-2xl bg-gray-100 dark:bg-gray-800/90 border border-gray-200/80 dark:border-gray-700/80 grid gap-1.5 shadow-inner", isPaperRecord.value ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-6'])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleTabs.value, (tab) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: tab.id,
                  type: "button",
                  class: _normalizeClass(["w-full px-2 py-2 sm:py-2.5 text-xs font-bold rounded-xl transition-all duration-200 flex items-center justify-center space-x-1.5 text-center truncate select-none", [
            activeTab.value === tab.id
              ? 'bg-white dark:bg-gray-700 text-secondary dark:text-secondary-dark-text shadow-sm ring-1 ring-black/5 dark:ring-white/10'
              : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-white/50 dark:hover:bg-gray-700/50'
          ]]),
                  onClick: ($event: any) => (activeTab.value = tab.id)
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(tab.icon), { class: "w-3.5 h-3.5 flex-shrink-0" })),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(tab.label), 1),
                  (tab.id === 'documents' && localDocuments.value.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(localDocuments.value.length), 1))
                    : (tab.id === 'print_pdf')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " PDF "))
                      : _createCommentVNode("", true)
                ], 10, _hoisted_16))
              }), 128))
            ], 2),
            _withDirectives(_createElementVNode("div", _hoisted_20, [
              (isPaperRecord.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_unref(FileText), { class: "w-5 h-5" })
                      ]),
                      _createElementVNode("div", null, [
                        _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "text-sm font-bold text-purple-900 dark:text-purple-200" }, " Digitized Paper Record ", -1)),
                        _createElementVNode("p", _hoisted_23, [
                          _cache[20] || (_cache[20] = _createTextVNode(" This record was digitized from an offline/paper application. Original scanned documents and physical paperwork attachments can be viewed and downloaded under the ", -1)),
                          _createElementVNode("button", {
                            type: "button",
                            class: "underline font-bold hover:text-purple-900 dark:hover:text-purple-100",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'documents'))
                          }, "Attachments"),
                          _cache[21] || (_cache[21] = _createTextVNode(" tab. ", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h3", _hoisted_25, [
                        _createVNode(_unref(User), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[23] || (_cache[23] = _createElementVNode("span", null, "1. Applicant Information", -1))
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", null, [
                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Full Legal Name", -1)),
                          _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.application.full_name), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Email Address", -1)),
                          _createElementVNode("p", _hoisted_28, _toDisplayString(isPlaceholderEmail(_ctx.application.email) ? 'Not provided (Digitized Paper Record)' : (_ctx.application.email || 'Not provided')), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Phone Number", -1)),
                          _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.application.phone_number || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Street / Residential Address", -1)),
                          _createElementVNode("p", _hoisted_31, _toDisplayString(formatAddress(_ctx.application) || 'Not provided'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Record Type", -1)),
                          _createElementVNode("p", _hoisted_32, [
                            _createVNode(_unref(FileText), { class: "w-3.5 h-3.5" }),
                            _cache[28] || (_cache[28] = _createElementVNode("span", null, "Offline / Paper Record", -1))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("h3", _hoisted_34, [
                        _createVNode(_unref(Briefcase), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[30] || (_cache[30] = _createElementVNode("span", null, "2. Position & Availability", -1))
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", null, [
                          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Position Applied / Hired For", -1)),
                          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.application.position_applied_for || 'Not specified'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Availability / Start Date", -1)),
                          _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.application.availability_date ? formatDate(_ctx.application.availability_date) : 'Not specified'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("h3", _hoisted_39, [
                        _createVNode(_unref(History), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[33] || (_cache[33] = _createElementVNode("span", null, "3. Previous Experience Summary", -1))
                      ]),
                      (_ctx.application.previous_experience)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.application.previous_experience), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_42, " No previous experience summary was entered for this paper record. "))
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("h3", _hoisted_44, [
                        _createVNode(_unref(ClipboardCheck), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "4. Administrator Remarks & Notes", -1))
                      ]),
                      (_ctx.application.admin_remarks)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.application.admin_remarks), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_47, " No administrative remarks logged. "))
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("h3", _hoisted_50, [
                          _createVNode(_unref(Paperclip), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _createElementVNode("span", null, "5. Scanned Documents & Attachments (" + _toDisplayString(localDocuments.value.length) + ")", 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "text-xs text-secondary dark:text-secondary-dark-text font-bold hover:underline flex items-center space-x-1",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (activeTab.value = 'documents'))
                        }, [...(_cache[35] || (_cache[35] = [
                          _createElementVNode("span", null, "Manage Attachments", -1),
                          _createElementVNode("span", null, "→", -1)
                        ]))])
                      ]),
                      (!localDocuments.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _cache[36] || (_cache[36] = _createTextVNode(" No physical documents were attached to this record yet. You can upload scanned copies in the ", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "underline font-bold text-secondary dark:text-secondary-dark-text",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = 'documents'))
                            }, "Attachments tab"),
                            _cache[37] || (_cache[37] = _createTextVNode(". ", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localDocuments.value, (doc) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: doc.document_id,
                                class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-200 dark:border-gray-700 flex items-center justify-between space-x-2"
                              }, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createVNode(_unref(FileText), { class: "w-4 h-4" })
                                  ]),
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("p", _hoisted_56, _toDisplayString(doc.file_name), 1),
                                    _createElementVNode("p", _hoisted_57, _toDisplayString(doc.document_category?.replace(/_/g, ' ') || 'paper record') + " • " + _toDisplayString(formatFileSize(doc.file_size)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "p-1.5 rounded-lg text-secondary dark:text-secondary-dark-text hover:bg-secondary/10 transition",
                                    title: "Preview Document",
                                    onClick: ($event: any) => (handlePreview(doc))
                                  }, [
                                    _createVNode(_unref(Eye), { class: "w-3.5 h-3.5" })
                                  ], 8, _hoisted_59),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "p-1.5 rounded-lg text-gray-600 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition",
                                    title: "Download Document",
                                    onClick: ($event: any) => (handleDownload(doc))
                                  }, [
                                    _createVNode(_unref(Download), { class: "w-3.5 h-3.5" })
                                  ], 8, _hoisted_60)
                                ])
                              ]))
                            }), 128))
                          ]))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("h3", _hoisted_62, [
                        _createVNode(_unref(User), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[38] || (_cache[38] = _createElementVNode("span", null, "1. Applicant Information", -1))
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", null, [
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Full Legal Name", -1)),
                          _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.application.full_name), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Email Address", -1)),
                          _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.application.email), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Phone Number", -1)),
                          _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.application.phone_number || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Street Address", -1)),
                          _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.application.street_address) + ", " + _toDisplayString(_ctx.application.city) + ", " + _toDisplayString(_ctx.application.state) + " " + _toDisplayString(_ctx.application.zip_code), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Date of Birth", -1)),
                          _createElementVNode("p", _hoisted_69, _toDisplayString(jobApp.value?.date_of_birth || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Social Security Number", -1)),
                          _createElementVNode("p", _hoisted_70, [
                            _createElementVNode("span", null, _toDisplayString(isSsnRevealed.value ? (formatFullSsn(applicantSsn.value) || 'N/A') : maskSsn(applicantSsn.value)), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "text-xs text-secondary dark:text-secondary-dark-text hover:underline",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (isSsnRevealed.value = !isSsnRevealed.value))
                            }, _toDisplayString(isSsnRevealed.value ? 'Hide' : 'Reveal'), 1)
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "NPI Number", -1)),
                          _createElementVNode("p", _hoisted_71, _toDisplayString(jobApp.value?.npi_number || 'None'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Work Authorization Eligibility", -1)),
                          _createElementVNode("p", _hoisted_72, _toDisplayString(jobApp.value?.is_legally_eligible_to_work ? 'Yes (Authorized to work in US)' : 'No'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("h3", _hoisted_74, [
                        _createVNode(_unref(Clock), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[47] || (_cache[47] = _createElementVNode("span", null, "2. Position & Availability", -1))
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", null, [
                          _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Position Applied", -1)),
                          _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.application.position_applied_for || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Employment Desired", -1)),
                          _createElementVNode("p", _hoisted_77, _toDisplayString(jobApp.value?.employment_desired || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Weekly Hours Available", -1)),
                          _createElementVNode("p", _hoisted_78, _toDisplayString(jobApp.value?.weekly_hours_available || '40') + " hrs/wk", 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Available Start Date", -1)),
                          _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.application.availability_date || jobApp.value?.date_available_for_work || 'Immediately'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _cache[52] || (_cache[52] = _createElementVNode("span", { class: "font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Days & Hours Available to Work", -1)),
                          (jobApp.value?.availability_no_pref)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_82, " ✓ Open Availability (No Preference) "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "MON", -1)),
                            _createElementVNode("span", _hoisted_85, _toDisplayString(jobApp.value?.available_mon || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _cache[54] || (_cache[54] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "TUE", -1)),
                            _createElementVNode("span", _hoisted_87, _toDisplayString(jobApp.value?.available_tue || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _cache[55] || (_cache[55] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "WED", -1)),
                            _createElementVNode("span", _hoisted_89, _toDisplayString(jobApp.value?.available_wed || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _cache[56] || (_cache[56] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "THU", -1)),
                            _createElementVNode("span", _hoisted_91, _toDisplayString(jobApp.value?.available_thur || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _cache[57] || (_cache[57] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "FRI", -1)),
                            _createElementVNode("span", _hoisted_93, _toDisplayString(jobApp.value?.available_fri || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "SAT", -1)),
                            _createElementVNode("span", _hoisted_95, _toDisplayString(jobApp.value?.available_sat || '—'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-[10px] text-gray-400 font-bold block" }, "SUN", -1)),
                            _createElementVNode("span", _hoisted_97, _toDisplayString(jobApp.value?.available_sun || '—'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("span", null, [
                            _cache[60] || (_cache[60] = _createTextVNode("Can work nights: ", -1)),
                            _createElementVNode("strong", _hoisted_99, _toDisplayString(jobApp.value?.can_work_nights || 'N/A'), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("h3", _hoisted_101, [
                        _createVNode(_unref(GraduationCap), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[61] || (_cache[61] = _createElementVNode("span", null, "3. Education History", -1))
                      ]),
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("table", _hoisted_103, [
                          _cache[62] || (_cache[62] = _createElementVNode("thead", { class: "text-[11px] uppercase bg-gray-100 dark:bg-gray-900/50 text-gray-600 dark:text-gray-400" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "p-2.5" }, "Level"),
                              _createElementVNode("th", { class: "p-2.5" }, "School Name"),
                              _createElementVNode("th", { class: "p-2.5" }, "Location"),
                              _createElementVNode("th", { class: "p-2.5" }, "Years Completed"),
                              _createElementVNode("th", { class: "p-2.5" }, "Major / Degree")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", _hoisted_104, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobApp.value?.education_history || [], (edu, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", _hoisted_105, _toDisplayString(edu.type), 1),
                                _createElementVNode("td", _hoisted_106, _toDisplayString(edu.name_of_school || '—'), 1),
                                _createElementVNode("td", _hoisted_107, _toDisplayString(edu.location || '—'), 1),
                                _createElementVNode("td", _hoisted_108, _toDisplayString(edu.years_completed || '—'), 1),
                                _createElementVNode("td", _hoisted_109, _toDisplayString(edu.major_degree || '—'), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("h3", _hoisted_111, [
                        _createVNode(_unref(Car), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[63] || (_cache[63] = _createElementVNode("span", null, "4. Background & Transportation", -1))
                      ]),
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", null, [
                          _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Convicted of Crime", -1)),
                          _createElementVNode("p", {
                            class: _normalizeClass(["font-bold", jobApp.value?.has_been_convicted_of_crime ? 'text-red-500' : 'text-gray-900 dark:text-white'])
                          }, _toDisplayString(jobApp.value?.has_been_convicted_of_crime ? 'Yes' : 'No'), 3),
                          (jobApp.value?.has_been_convicted_of_crime)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(jobApp.value?.crime_conviction_explanation), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[65] || (_cache[65] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Driver's License", -1)),
                          _createElementVNode("p", _hoisted_114, _toDisplayString(jobApp.value?.has_driver_license ? `Yes (${jobApp.value?.driver_license_state} #${jobApp.value?.driver_license_number || 'N/A'})` : 'No'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[66] || (_cache[66] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Transportation Means", -1)),
                          _createElementVNode("p", _hoisted_115, _toDisplayString(jobApp.value?.transportation_means || 'Personal Vehicle'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("h3", _hoisted_117, [
                        _createVNode(_unref(Cpu), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[67] || (_cache[67] = _createElementVNode("span", null, "5. Computer & Administrative Skills", -1))
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        (jobApp.value?.skill_windows)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_119, "✓ Windows OS"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_word)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_120, "✓ MS Word"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_excel)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_121, "✓ MS Excel"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_powerpoint)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_122, "✓ PowerPoint"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_access)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_123, "✓ MS Access"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_publisher)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_124, "✓ MS Publisher"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_typing)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_125, "✓ Fast Typing"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_wordperfect)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_126, "✓ WordPerfect"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_pc)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_127, "✓ PC Architecture"))
                          : _createCommentVNode("", true),
                        (jobApp.value?.skill_mac)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_128, "✓ Mac OS"))
                          : _createCommentVNode("", true)
                      ]),
                      (jobApp.value?.other_skills)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                            _cache[68] || (_cache[68] = _createElementVNode("span", { class: "font-bold text-gray-700 dark:text-gray-300" }, "Other Skills & Certifications:", -1)),
                            _createElementVNode("p", _hoisted_130, _toDisplayString(jobApp.value.other_skills), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("h3", _hoisted_132, [
                        _createVNode(_unref(Briefcase), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[69] || (_cache[69] = _createElementVNode("span", null, "6. Previous Work Experiences", -1))
                      ]),
                      (!jobApp.value?.work_experiences?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_133, " No work experiences submitted. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_134, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobApp.value.work_experiences, (work, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: "p-4 rounded-xl bg-gray-50 dark:bg-gray-900/40 border border-gray-100 dark:border-gray-800 space-y-2 text-xs"
                              }, [
                                _createElementVNode("div", _hoisted_135, [
                                  _createElementVNode("span", _hoisted_136, _toDisplayString(work.name_of_employer || `Employer #${idx + 1}`), 1),
                                  _createElementVNode("span", _hoisted_137, _toDisplayString(work.from_date) + " - " + _toDisplayString(work.to_date || 'Present'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_138, [
                                  _createElementVNode("p", null, [
                                    _cache[70] || (_cache[70] = _createElementVNode("span", { class: "font-semibold text-gray-700 dark:text-gray-200" }, "Title:", -1)),
                                    _createTextVNode(" " + _toDisplayString(work.last_job_title || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("p", null, [
                                    _cache[71] || (_cache[71] = _createElementVNode("span", { class: "font-semibold text-gray-700 dark:text-gray-200" }, "Supervisor:", -1)),
                                    _createTextVNode(" " + _toDisplayString(work.last_supervisor || 'N/A'), 1)
                                  ]),
                                  _createElementVNode("p", null, [
                                    _cache[72] || (_cache[72] = _createElementVNode("span", { class: "font-semibold text-gray-700 dark:text-gray-200" }, "Phone:", -1)),
                                    _createTextVNode(" " + _toDisplayString(work.phone_number || 'N/A'), 1)
                                  ])
                                ]),
                                (work.duties_skills_promotions)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_139, [
                                      _cache[73] || (_cache[73] = _createElementVNode("span", { class: "font-semibold text-gray-700 dark:text-gray-200" }, "Duties / Skills:", -1)),
                                      _createTextVNode(" " + _toDisplayString(work.duties_skills_promotions), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("h3", _hoisted_142, [
                          _createVNode(_unref(Users), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _cache[74] || (_cache[74] = _createElementVNode("span", null, "7. Employment References (3 References)", -1))
                        ]),
                        (displayReferences.value?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["px-2.5 py-0.5 rounded-full text-xs font-bold inline-flex items-center space-x-1 border shadow-2xs", 
                  verifiedReferencesCount.value === displayReferences.value.length
                    ? 'bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800'
                    : verifiedReferencesCount.value > 0
                    ? 'bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800'
                    : 'bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800'
                ])
                              }, [
                                (verifiedReferencesCount.value === displayReferences.value.length)
                                  ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                                      key: 0,
                                      class: "w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(Clock), {
                                      key: 1,
                                      class: "w-3.5 h-3.5 text-amber-600 dark:text-amber-400"
                                    })),
                                _createElementVNode("span", null, _toDisplayString(verifiedReferencesCount.value) + " of " + _toDisplayString(displayReferences.value.length) + " Verified", 1)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!displayReferences.value?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_144, " No employment references submitted. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_145, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayReferences.value, (refItem, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx,
                                class: _normalizeClass(["p-4 rounded-xl border flex flex-col justify-between space-y-3 text-xs transition-all duration-200", 
                refItem.is_verified
                  ? 'bg-emerald-50/40 dark:bg-emerald-950/20 border-emerald-300/80 dark:border-emerald-800/60 shadow-xs'
                  : 'bg-gray-50 dark:bg-gray-900/40 border-gray-200 dark:border-gray-800'
              ])
                              }, [
                                _createElementVNode("div", _hoisted_146, [
                                  _createElementVNode("div", _hoisted_147, [
                                    _createElementVNode("div", _hoisted_148, [
                                      _createElementVNode("span", _hoisted_149, " Reference #" + _toDisplayString(idx + 1), 1),
                                      _createElementVNode("h4", {
                                        class: "font-bold text-sm text-gray-900 dark:text-white truncate",
                                        title: refItem.name
                                      }, _toDisplayString(refItem.name || `Reference #${idx + 1}`), 9, _hoisted_150)
                                    ]),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["px-2 py-0.5 rounded-full text-[10px] font-bold inline-flex items-center space-x-1 shrink-0 border", 
                      refItem.is_verified
                        ? 'bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-900/70 dark:text-emerald-200 dark:border-emerald-700'
                        : 'bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-900/60 dark:text-amber-200 dark:border-amber-700'
                    ])
                                    }, [
                                      (refItem.is_verified)
                                        ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                                            key: 0,
                                            class: "w-3 h-3 text-emerald-600 dark:text-emerald-300"
                                          }))
                                        : (_openBlock(), _createBlock(_unref(Clock), {
                                            key: 1,
                                            class: "w-3 h-3 text-amber-600 dark:text-amber-300"
                                          })),
                                      _createElementVNode("span", null, _toDisplayString(refItem.is_verified ? 'Verified' : 'Pending'), 1)
                                    ], 2)
                                  ]),
                                  _createElementVNode("p", _hoisted_151, _toDisplayString(refItem.position_title || 'Position N/A') + " • " + _toDisplayString(refItem.organization || 'Org N/A'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_152, [
                                  _createElementVNode("p", _hoisted_153, [
                                    _createVNode(_unref(Phone), { class: "w-3 h-3 text-gray-400 shrink-0" }),
                                    _cache[75] || (_cache[75] = _createElementVNode("span", null, "Phone:", -1)),
                                    (refItem.phone_number)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: `tel:${refItem.phone_number}`,
                                          class: "font-semibold text-gray-900 dark:text-gray-100 hover:text-secondary dark:hover:text-secondary-dark-text hover:underline"
                                        }, _toDisplayString(refItem.phone_number), 9, _hoisted_154))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_155, "N/A"))
                                  ]),
                                  _createElementVNode("p", _hoisted_156, [
                                    _createVNode(_unref(Mail), { class: "w-3 h-3 text-gray-400 shrink-0" }),
                                    _cache[76] || (_cache[76] = _createElementVNode("span", null, "Email:", -1)),
                                    (refItem.email)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: `mailto:${refItem.email}`,
                                          class: "font-semibold text-gray-900 dark:text-gray-100 hover:text-secondary dark:hover:text-secondary-dark-text hover:underline truncate"
                                        }, _toDisplayString(refItem.email), 9, _hoisted_157))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_158, "N/A"))
                                  ])
                                ]),
                                (refItem.is_verified)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                                      _createVNode(_unref(ShieldCheck), { class: "w-3.5 h-3.5 text-emerald-600 dark:text-emerald-400 shrink-0 mt-0.5" }),
                                      _createElementVNode("div", _hoisted_160, [
                                        _createElementVNode("p", _hoisted_161, "Verified by " + _toDisplayString(refItem.verified_by || 'Admin'), 1),
                                        (refItem.verified_at)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_162, _toDisplayString(formatDate(refItem.verified_at)), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (refItem.verification_notes && editingNoteIndex.value !== idx)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _createElementVNode("div", _hoisted_164, [
                                        _createElementVNode("span", _hoisted_165, [
                                          _createVNode(_unref(MessageSquare), { class: "w-3 h-3" }),
                                          _cache[77] || (_cache[77] = _createElementVNode("span", null, "Admin Notes", -1))
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "hover:text-secondary dark:hover:text-secondary-dark-text underline cursor-pointer",
                                          onClick: ($event: any) => (openEditNotes(idx))
                                        }, " Edit ", 8, _hoisted_166)
                                      ]),
                                      _createElementVNode("p", _hoisted_167, _toDisplayString(refItem.verification_notes), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (editingNoteIndex.value === idx)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
                                      _createElementVNode("div", _hoisted_169, [
                                        _createElementVNode("span", _hoisted_170, [
                                          _createVNode(_unref(MessageSquare), { class: "w-3 h-3 text-secondary dark:text-secondary-dark-text" }),
                                          _cache[78] || (_cache[78] = _createElementVNode("span", null, "Verification Notes", -1))
                                        ]),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 cursor-pointer",
                                          onClick: cancelEditNotes
                                        }, [
                                          _createVNode(_unref(X), { class: "w-3.5 h-3.5" })
                                        ])
                                      ]),
                                      _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editingNoteText).value = $event)),
                                        rows: "2",
                                        maxlength: "1000",
                                        class: "w-full text-xs p-2 rounded-lg border border-gray-300 dark:border-gray-600 dark:bg-gray-900/60 dark:text-white focus:ring-1 focus:ring-secondary focus:border-secondary outline-none resize-none",
                                        placeholder: "Record conversation details, feedback, or comments..."
                                      }, null, 512), [
                                        [_vModelText, editingNoteText.value]
                                      ]),
                                      _createElementVNode("div", _hoisted_171, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "px-2 py-1 rounded text-[11px] font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer",
                                          onClick: cancelEditNotes
                                        }, " Cancel "),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "px-2.5 py-1 rounded text-[11px] font-bold bg-secondary hover:bg-secondary-dark text-white flex items-center space-x-1 cursor-pointer",
                                          disabled: savingIndex.value === idx,
                                          onClick: ($event: any) => (saveNotesOnly(idx))
                                        }, [
                                          (savingIndex.value === idx)
                                            ? (_openBlock(), _createBlock(_unref(Loader2), {
                                                key: 0,
                                                class: "w-3 h-3 animate-spin"
                                              }))
                                            : _createCommentVNode("", true),
                                          _cache[79] || (_cache[79] = _createElementVNode("span", null, "Save Note", -1))
                                        ], 8, _hoisted_172)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_173, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(["flex-1 py-1.5 px-2.5 rounded-lg text-xs font-bold transition-colors inline-flex items-center justify-center space-x-1.5 cursor-pointer shadow-2xs", 
                    refItem.is_verified
                      ? 'bg-gray-100 text-gray-700 hover:bg-red-50 hover:text-red-700 hover:border-red-200 border border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-red-950/40 dark:hover:text-red-300'
                      : 'bg-emerald-600 text-white hover:bg-emerald-700 dark:bg-emerald-600 dark:hover:bg-emerald-500'
                  ]),
                                    disabled: savingIndex.value === idx,
                                    onClick: ($event: any) => (toggleReferenceVerification(idx))
                                  }, [
                                    (savingIndex.value === idx)
                                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                                          key: 0,
                                          class: "w-3.5 h-3.5 animate-spin"
                                        }))
                                      : (refItem.is_verified)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_unref(X), { class: "w-3.5 h-3.5 text-gray-500 hover:text-red-600" }),
                                            _cache[80] || (_cache[80] = _createElementVNode("span", null, "Unmark Verified", -1))
                                          ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _createVNode(_unref(Check), { class: "w-3.5 h-3.5" }),
                                            _cache[81] || (_cache[81] = _createElementVNode("span", null, "Verify Reference", -1))
                                          ], 64))
                                  ], 10, _hoisted_174),
                                  (editingNoteIndex.value !== idx)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "py-1.5 px-2 rounded-lg text-xs font-medium text-gray-600 dark:text-gray-300 hover:bg-gray-200/60 dark:hover:bg-gray-800 border border-gray-200 dark:border-gray-700 inline-flex items-center space-x-1 cursor-pointer",
                                        title: refItem.verification_notes ? 'Edit note' : 'Add note',
                                        onClick: ($event: any) => (openEditNotes(idx))
                                      }, [
                                        (refItem.verification_notes)
                                          ? (_openBlock(), _createBlock(_unref(Edit3), {
                                              key: 0,
                                              class: "w-3 h-3"
                                            }))
                                          : (_openBlock(), _createBlock(_unref(MessageSquare), {
                                              key: 1,
                                              class: "w-3 h-3"
                                            })),
                                        _createElementVNode("span", null, _toDisplayString(refItem.verification_notes ? 'Edit' : 'Note'), 1)
                                      ], 8, _hoisted_175))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_176, [
                      _createElementVNode("h3", _hoisted_177, [
                        _createVNode(_unref(CheckCircle2), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                        _cache[82] || (_cache[82] = _createElementVNode("span", null, "8. Signatures & Waivers", -1))
                      ]),
                      _createElementVNode("div", _hoisted_178, [
                        _createElementVNode("div", _hoisted_179, [
                          _cache[83] || (_cache[83] = _createElementVNode("span", { class: "text-gray-500 font-medium" }, "Application Form Waiver Signature", -1)),
                          _createElementVNode("p", _hoisted_180, _toDisplayString(jobApp.value?.waiver_signature || 'N/A'), 1),
                          _createElementVNode("p", _hoisted_181, "Date: " + _toDisplayString(jobApp.value?.waiver_date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_182, [
                          _cache[84] || (_cache[84] = _createElementVNode("span", { class: "text-gray-500 font-medium" }, "Job Description Acknowledgment Signature", -1)),
                          _createElementVNode("p", _hoisted_183, _toDisplayString(jobApp.value?.job_description_signature || 'N/A'), 1),
                          _createElementVNode("p", _hoisted_184, "Date: " + _toDisplayString(jobApp.value?.job_description_date), 1)
                        ])
                      ])
                    ])
                  ], 64))
            ], 512), [
              [_vShow, activeTab.value === 'job_application']
            ]),
            (!isPaperRecord.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_185, [
                  _createElementVNode("div", _hoisted_186, [
                    _createElementVNode("h3", _hoisted_187, [
                      _createVNode(_unref(ShieldCheck), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                      _cache[85] || (_cache[85] = _createElementVNode("span", null, "Background Check Requirements & Acknowledgment", -1))
                    ]),
                    _createElementVNode("div", _hoisted_188, [
                      _createElementVNode("div", _hoisted_189, [
                        _cache[86] || (_cache[86] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Requirements Acknowledged", -1)),
                        _createElementVNode("p", {
                          class: _normalizeClass(["font-bold mt-1", _ctx.application.background_check_data?.acknowledges_requirements ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-500'])
                        }, _toDisplayString(_ctx.application.background_check_data?.acknowledges_requirements ? '✓ Yes, Confirmed' : '✗ Not Acknowledged'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_190, [
                        _cache[87] || (_cache[87] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Full Legal Name Signed", -1)),
                        _createElementVNode("p", _hoisted_191, _toDisplayString(_ctx.application.background_check_data?.applicant_name || _ctx.application.full_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_192, [
                        _cache[88] || (_cache[88] = _createElementVNode("span", { class: "text-xs text-gray-500 dark:text-gray-400 font-medium" }, "Signed Date", -1)),
                        _createElementVNode("p", _hoisted_193, _toDisplayString(_ctx.application.background_check_data?.acknowledged_at || formatDate(_ctx.application.submitted_at)), 1)
                      ])
                    ])
                  ])
                ], 512)), [
                  [_vShow, activeTab.value === 'background_check']
                ])
              : _createCommentVNode("", true),
            (!isPaperRecord.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_194, [
                  _createElementVNode("div", _hoisted_195, [
                    _createElementVNode("div", _hoisted_196, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_197, [
                          _createVNode(_unref(Receipt), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _cache[89] || (_cache[89] = _createElementVNode("span", null, "1. State of Maryland Form MW507", -1))
                        ]),
                        _cache[90] || (_cache[90] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Employee's Maryland Withholding Exemption Certificate", -1))
                      ]),
                      _cache[91] || (_cache[91] = _createElementVNode("span", { class: "px-2.5 py-1 rounded-full text-xs font-bold bg-secondary/10 text-secondary dark:text-secondary-dark-text" }, " State Tax ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_198, [
                      _cache[97] || (_cache[97] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Personal & Filing Information", -1)),
                      _createElementVNode("div", _hoisted_199, [
                        _createElementVNode("div", _hoisted_200, [
                          _cache[92] || (_cache[92] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Full Name on MW507", -1)),
                          _createElementVNode("p", _hoisted_201, _toDisplayString(taxDocs.value?.mw507?.full_name || _ctx.application.full_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_202, [
                          _cache[93] || (_cache[93] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Social Security Number", -1)),
                          _createElementVNode("p", _hoisted_203, _toDisplayString(isSsnRevealed.value ? (formatFullSsn(taxDocs.value?.mw507?.social_security_number || applicantSsn.value) || 'N/A') : maskSsn(taxDocs.value?.mw507?.social_security_number || applicantSsn.value)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_204, [
                          _cache[94] || (_cache[94] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Maryland Filing Status", -1)),
                          _createElementVNode("p", _hoisted_205, _toDisplayString(taxDocs.value?.mw507?.filing_status || 'Single'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_206, [
                          _cache[95] || (_cache[95] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Residential Street Address", -1)),
                          _createElementVNode("p", _hoisted_207, _toDisplayString(taxDocs.value?.mw507?.street_address || 'N/A') + ", " + _toDisplayString(taxDocs.value?.mw507?.city || '') + " " + _toDisplayString(taxDocs.value?.mw507?.state || 'MD') + " " + _toDisplayString(taxDocs.value?.mw507?.zip_code || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_208, [
                          _cache[96] || (_cache[96] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "County of Residence / Employment", -1)),
                          _createElementVNode("p", _hoisted_209, _toDisplayString(taxDocs.value?.mw507?.county_of_residence || 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_210, [
                      _cache[102] || (_cache[102] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Withholding Allowances & Special Exemptions", -1)),
                      _createElementVNode("div", _hoisted_211, [
                        _createElementVNode("div", _hoisted_212, [
                          _cache[98] || (_cache[98] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Line 1: Total Exemptions Claimed", -1)),
                          _createElementVNode("p", _hoisted_213, _toDisplayString(taxDocs.value?.mw507?.line1_total_exemptions ?? '1'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_214, [
                          _cache[99] || (_cache[99] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Line 2: Additional Withholding", -1)),
                          _createElementVNode("p", _hoisted_215, "$" + _toDisplayString(taxDocs.value?.mw507?.line2_additional_withholding || '0') + " / pay period", 1)
                        ]),
                        _createElementVNode("div", _hoisted_216, [
                          _cache[100] || (_cache[100] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Line 3: Exemption from Tax", -1)),
                          _createElementVNode("p", {
                            class: _normalizeClass(["font-bold mt-0.5", (taxDocs.value?.mw507?.line3_a_last_year_no_tax || taxDocs.value?.mw507?.line3_b_this_year_no_tax) ? 'text-amber-600 dark:text-amber-400' : 'text-gray-700 dark:text-gray-300'])
                          }, [
                            (taxDocs.value?.mw507?.line3_a_last_year_no_tax && taxDocs.value?.mw507?.line3_b_this_year_no_tax)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_217, "Full Exemption (3a & 3b)"))
                              : (taxDocs.value?.mw507?.line3_a_last_year_no_tax)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_218, "Claimed (Last year no tax)"))
                                : (taxDocs.value?.mw507?.line3_b_this_year_no_tax)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_219, "Claimed (This year no tax)"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_220, "No Exemption Claimed"))
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_221, [
                          _cache[101] || (_cache[101] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Line 4 / Line 8 Reciprocity State", -1)),
                          _createElementVNode("p", _hoisted_222, _toDisplayString(taxDocs.value?.mw507?.line4_domiciled_state || taxDocs.value?.mw507?.line8_military_spouse_state || 'None (MD Resident)'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_223, [
                      _createElementVNode("div", null, [
                        _cache[103] || (_cache[103] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "MW507 Employee Digital Signature:", -1)),
                        _createElementVNode("strong", _hoisted_224, _toDisplayString(taxDocs.value?.mw507?.employee_signature || _ctx.application.full_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_225, [
                        _cache[104] || (_cache[104] = _createTextVNode(" Date Signed: ", -1)),
                        _createElementVNode("strong", _hoisted_226, _toDisplayString(taxDocs.value?.mw507?.signature_date || 'N/A'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_227, [
                    _createElementVNode("div", _hoisted_228, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_229, [
                          _createVNode(_unref(ShieldCheck), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _cache[105] || (_cache[105] = _createElementVNode("span", null, "2. USCIS Form I-9 (Section 1)", -1))
                        ]),
                        _cache[106] || (_cache[106] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Employment Eligibility Verification — Department of Homeland Security", -1))
                      ]),
                      _cache[107] || (_cache[107] = _createElementVNode("span", { class: "px-2.5 py-1 rounded-full text-xs font-bold bg-secondary/10 text-secondary dark:text-secondary-dark-text" }, " Federal Verification ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_230, [
                      _cache[115] || (_cache[115] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Employee Information", -1)),
                      _createElementVNode("div", _hoisted_231, [
                        _createElementVNode("div", _hoisted_232, [
                          _cache[108] || (_cache[108] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Employee Name", -1)),
                          _createElementVNode("p", _hoisted_233, _toDisplayString(taxDocs.value?.i9?.first_name || '') + " " + _toDisplayString(taxDocs.value?.i9?.middle_initial ? taxDocs.value?.i9?.middle_initial + '.' : '') + " " + _toDisplayString(taxDocs.value?.i9?.last_name || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_234, [
                          _cache[109] || (_cache[109] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Other Last Names Used", -1)),
                          _createElementVNode("p", _hoisted_235, _toDisplayString(taxDocs.value?.i9?.other_last_names || 'None'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_236, [
                          _cache[110] || (_cache[110] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Date of Birth", -1)),
                          _createElementVNode("p", _hoisted_237, _toDisplayString(taxDocs.value?.i9?.date_of_birth || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_238, [
                          _cache[111] || (_cache[111] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "U.S. Social Security Number", -1)),
                          _createElementVNode("p", _hoisted_239, _toDisplayString(isSsnRevealed.value ? (formatFullSsn(taxDocs.value?.i9?.social_security_number || applicantSsn.value) || 'N/A') : maskSsn(taxDocs.value?.i9?.social_security_number || applicantSsn.value)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_240, [
                          _cache[112] || (_cache[112] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Address", -1)),
                          _createElementVNode("p", _hoisted_241, _toDisplayString(taxDocs.value?.i9?.address || 'N/A') + " " + _toDisplayString(taxDocs.value?.i9?.apt_number ? 'Apt/Ste ' + taxDocs.value?.i9?.apt_number : '') + ", " + _toDisplayString(taxDocs.value?.i9?.city || '') + " " + _toDisplayString(taxDocs.value?.i9?.state || 'MD') + " " + _toDisplayString(taxDocs.value?.i9?.zip_code || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_242, [
                          _cache[113] || (_cache[113] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Email Address", -1)),
                          _createElementVNode("p", _hoisted_243, _toDisplayString(taxDocs.value?.i9?.email_address || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_244, [
                          _cache[114] || (_cache[114] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Telephone Number", -1)),
                          _createElementVNode("p", _hoisted_245, _toDisplayString(taxDocs.value?.i9?.telephone_number || 'N/A'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_246, [
                      _cache[120] || (_cache[120] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Citizenship & Employment Eligibility Attestation", -1)),
                      _createElementVNode("div", _hoisted_247, [
                        _createElementVNode("div", _hoisted_248, [
                          _cache[116] || (_cache[116] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Attested Citizenship Status", -1)),
                          _createElementVNode("p", _hoisted_249, [
                            (taxDocs.value?.i9?.citizenship_status === 'citizen')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_250, "1. U.S. Citizen"))
                              : (taxDocs.value?.i9?.citizenship_status === 'noncitizen_national')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_251, "2. U.S. Noncitizen National"))
                                : (taxDocs.value?.i9?.citizenship_status === 'lawful_permanent_resident')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_252, "3. Lawful Permanent Resident"))
                                  : (taxDocs.value?.i9?.citizenship_status === 'alien_authorized')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_253, "4. Authorized Alien"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_254, _toDisplayString(taxDocs.value?.i9?.citizenship_status || 'Citizen'), 1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_255, [
                          _cache[117] || (_cache[117] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Alien / USCIS / Admission #", -1)),
                          _createElementVNode("p", _hoisted_256, _toDisplayString(taxDocs.value?.i9?.alien_registration_number || taxDocs.value?.i9?.work_auth_doc_number || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_257, [
                          _cache[118] || (_cache[118] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Work Authorization Expiration", -1)),
                          _createElementVNode("p", _hoisted_258, _toDisplayString(taxDocs.value?.i9?.alien_authorized_expiration_date || 'No Expiration (Citizen / Permanent)'), 1)
                        ]),
                        (taxDocs.value?.i9?.work_auth_doc_type)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                              _cache[119] || (_cache[119] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Document Type & Issuing Country", -1)),
                              _createElementVNode("p", _hoisted_260, _toDisplayString(taxDocs.value?.i9?.work_auth_doc_type) + " " + _toDisplayString(taxDocs.value?.i9?.foreign_passport_country ? '(' + taxDocs.value?.i9?.foreign_passport_country + ')' : ''), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_261, [
                      _createElementVNode("div", null, [
                        _cache[121] || (_cache[121] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "I-9 Employee Attestation Signature:", -1)),
                        _createElementVNode("strong", _hoisted_262, _toDisplayString(taxDocs.value?.i9?.employee_signature || _ctx.application.full_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_263, [
                        _cache[122] || (_cache[122] = _createTextVNode(" Date Signed: ", -1)),
                        _createElementVNode("strong", _hoisted_264, _toDisplayString(taxDocs.value?.i9?.signature_date || 'N/A'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_265, [
                    _createElementVNode("div", _hoisted_266, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_267, [
                          _createVNode(_unref(Receipt), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _cache[123] || (_cache[123] = _createElementVNode("span", null, "3. IRS Form W-4 (2022)", -1))
                        ]),
                        _cache[124] || (_cache[124] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400" }, "Employee's Withholding Certificate — Federal Income Tax Withholding", -1))
                      ]),
                      _cache[125] || (_cache[125] = _createElementVNode("span", { class: "px-2.5 py-1 rounded-full text-xs font-bold bg-secondary/10 text-secondary dark:text-secondary-dark-text" }, " Federal Tax ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_268, [
                      _cache[131] || (_cache[131] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Step 1 & 2: Personal Information & Multiple Jobs", -1)),
                      _createElementVNode("div", _hoisted_269, [
                        _createElementVNode("div", _hoisted_270, [
                          _cache[126] || (_cache[126] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Name on W-4", -1)),
                          _createElementVNode("p", _hoisted_271, _toDisplayString(taxDocs.value?.w4?.first_name_middle_initial || '') + " " + _toDisplayString(taxDocs.value?.w4?.last_name || _ctx.application.full_name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_272, [
                          _cache[127] || (_cache[127] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Social Security Number", -1)),
                          _createElementVNode("p", _hoisted_273, _toDisplayString(isSsnRevealed.value ? (formatFullSsn(taxDocs.value?.w4?.social_security_number || applicantSsn.value) || 'N/A') : maskSsn(taxDocs.value?.w4?.social_security_number || applicantSsn.value)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_274, [
                          _cache[128] || (_cache[128] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Federal Filing Status", -1)),
                          _createElementVNode("p", _hoisted_275, _toDisplayString(taxDocs.value?.w4?.filing_status || 'Single or Married filing separately'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_276, [
                          _cache[129] || (_cache[129] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Address on W-4", -1)),
                          _createElementVNode("p", _hoisted_277, _toDisplayString(taxDocs.value?.w4?.address || 'N/A') + ", " + _toDisplayString(taxDocs.value?.w4?.city_state_zip || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_278, [
                          _cache[130] || (_cache[130] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 2: Multiple Jobs or Spouse Works", -1)),
                          _createElementVNode("p", {
                            class: _normalizeClass(["font-bold mt-0.5", taxDocs.value?.w4?.step2_multiple_jobs_or_spouse_works ? 'text-amber-600 dark:text-amber-400' : 'text-gray-700 dark:text-gray-300'])
                          }, _toDisplayString(taxDocs.value?.w4?.step2_multiple_jobs_or_spouse_works ? '✓ Yes (Two Jobs / Spouse Works checked)' : 'No (Standard withholding)'), 3)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_279, [
                      _cache[138] || (_cache[138] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wider" }, "Step 3 & 4: Claim Dependents & Other Adjustments", -1)),
                      _createElementVNode("div", _hoisted_280, [
                        _createElementVNode("div", _hoisted_281, [
                          _cache[132] || (_cache[132] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 3: Qualifying Children under 17", -1)),
                          _createElementVNode("p", _hoisted_282, "$" + _toDisplayString(taxDocs.value?.w4?.step3_qualifying_children_amount || '0.00'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_283, [
                          _cache[133] || (_cache[133] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 3: Other Dependents", -1)),
                          _createElementVNode("p", _hoisted_284, "$" + _toDisplayString(taxDocs.value?.w4?.step3_other_dependents_amount || '0.00'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_285, [
                          _cache[134] || (_cache[134] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 3: Total Dependent Amount", -1)),
                          _createElementVNode("p", _hoisted_286, "$" + _toDisplayString(taxDocs.value?.w4?.step3_total_dependent_amount || '0.00'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_287, [
                          _cache[135] || (_cache[135] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 4(a): Other Income (not from jobs)", -1)),
                          _createElementVNode("p", _hoisted_288, "$" + _toDisplayString(taxDocs.value?.w4?.step4a_other_income_amount || '0.00'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_289, [
                          _cache[136] || (_cache[136] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 4(b): Deductions", -1)),
                          _createElementVNode("p", _hoisted_290, "$" + _toDisplayString(taxDocs.value?.w4?.step4b_deductions_amount || '0.00'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_291, [
                          _cache[137] || (_cache[137] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400 block font-medium" }, "Step 4(c): Extra Withholding per pay period", -1)),
                          _createElementVNode("p", _hoisted_292, "$" + _toDisplayString(taxDocs.value?.w4?.step4c_extra_withholding_amount || '0.00'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_293, [
                      _createElementVNode("div", null, [
                        _cache[139] || (_cache[139] = _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, "W-4 Employee Digital Signature:", -1)),
                        _createElementVNode("strong", _hoisted_294, _toDisplayString(taxDocs.value?.w4?.employee_signature || _ctx.application.full_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_295, [
                        _cache[140] || (_cache[140] = _createTextVNode(" Date Signed: ", -1)),
                        _createElementVNode("strong", _hoisted_296, _toDisplayString(taxDocs.value?.w4?.signature_date || 'N/A'), 1)
                      ])
                    ])
                  ])
                ], 512)), [
                  [_vShow, activeTab.value === 'tax_docs']
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_297, [
              _createElementVNode("div", _hoisted_298, [
                _createElementVNode("div", _hoisted_299, [
                  _createElementVNode("h3", _hoisted_300, [
                    _createVNode(_unref(Paperclip), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                    _createElementVNode("span", null, "Attached Application Documents (" + _toDisplayString(localDocuments.value.length) + ")", 1)
                  ]),
                  _createVNode(_unref(BaseButton), {
                    variant: "outline",
                    size: "sm",
                    text: "Upload Document",
                    icon: _unref(UploadCloud),
                    "icon-position": "left",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (isUploadModalOpen.value = true))
                  }, null, 8, ["icon"])
                ]),
                (!localDocuments.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_301, " No document attachments were uploaded for this application. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_302, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localDocuments.value, (doc) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: doc.document_id,
                          class: "p-4 rounded-2xl bg-gray-50 dark:bg-gray-900/50 border border-gray-200 dark:border-gray-700 flex items-center justify-between space-x-3"
                        }, [
                          _createElementVNode("div", _hoisted_303, [
                            _createElementVNode("div", _hoisted_304, [
                              _createVNode(_unref(FileText), { class: "w-6 h-6" })
                            ]),
                            _createElementVNode("div", _hoisted_305, [
                              _createElementVNode("p", _hoisted_306, _toDisplayString(doc.file_name), 1),
                              _createElementVNode("div", _hoisted_307, [
                                _createElementVNode("span", _hoisted_308, _toDisplayString(doc.document_category || 'general'), 1),
                                _createElementVNode("span", null, _toDisplayString(formatFileSize(doc.file_size)), 1),
                                (doc.expiry_date)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_309, " Expires: " + _toDisplayString(doc.expiry_date), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_310, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "p-2 rounded-xl text-secondary dark:text-secondary-dark-text hover:bg-secondary/10 transition",
                              title: "Preview Document",
                              onClick: ($event: any) => (handlePreview(doc))
                            }, [
                              _createVNode(_unref(Eye), { class: "w-4 h-4" })
                            ], 8, _hoisted_311),
                            _createElementVNode("button", {
                              type: "button",
                              class: "p-2 rounded-xl text-secondary dark:text-secondary-dark-text hover:bg-secondary/10 transition",
                              title: "Download File",
                              onClick: ($event: any) => (handleDownload(doc))
                            }, [
                              _createVNode(_unref(Download), { class: "w-4 h-4" })
                            ], 8, _hoisted_312)
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ], 512), [
              [_vShow, activeTab.value === 'documents']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_313, [
              _createElementVNode("div", _hoisted_314, [
                _createElementVNode("div", _hoisted_315, [
                  _createElementVNode("h3", _hoisted_316, [
                    _createVNode(_unref(History), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                    _cache[141] || (_cache[141] = _createElementVNode("span", null, "Admin Review & Decision Status", -1))
                  ]),
                  _createVNode(_unref(BaseButton), {
                    variant: "outline",
                    size: "sm",
                    text: "Update Status / Remarks",
                    icon: _unref(ClipboardCheck),
                    "icon-position": "left",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('review', _ctx.application)))
                  }, null, 8, ["icon"])
                ]),
                _createElementVNode("div", _hoisted_317, [
                  _createElementVNode("div", _hoisted_318, [
                    _cache[142] || (_cache[142] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-500 dark:text-gray-400" }, "Current Status", -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["inline-flex items-center px-3 py-1 rounded-full text-xs font-bold", getStatusBadgeClass(_ctx.application.application_status)])
                      }, _toDisplayString(formatStatus(_ctx.application.application_status)), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_319, [
                    _cache[143] || (_cache[143] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-500 dark:text-gray-400" }, "Reviewed By", -1)),
                    _createElementVNode("p", _hoisted_320, _toDisplayString(_ctx.application.reviewer?.email || (_ctx.application.fk_reviewed_by ? `Admin #${_ctx.application.fk_reviewed_by}` : 'Pending Assignment')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_321, [
                    _cache[144] || (_cache[144] = _createElementVNode("span", { class: "text-xs font-semibold text-gray-500 dark:text-gray-400" }, "Decision Date", -1)),
                    _createElementVNode("p", _hoisted_322, _toDisplayString(_ctx.application.reviewed_at ? formatDate(_ctx.application.reviewed_at) : 'Not reviewed yet'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_323, [
                  _createElementVNode("div", _hoisted_324, [
                    _createVNode(_unref(FileText), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                    _cache[145] || (_cache[145] = _createElementVNode("span", null, "Admin Remarks & Interview Notes", -1))
                  ]),
                  (_ctx.application.admin_remarks)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_325, _toDisplayString(_ctx.application.admin_remarks), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_326, " No remarks or notes have been logged for this application yet. "))
                ]),
                (_ctx.application.application_status === 'approved' || _ctx.application.record_type === 'paper' || _ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["p-5 rounded-2xl border space-y-3", [
              (_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id)
                ? 'bg-emerald-50/70 dark:bg-emerald-950/30 border-emerald-200/80 dark:border-emerald-800/50'
                : 'bg-amber-50/70 dark:bg-amber-950/30 border-amber-200/80 dark:border-amber-800/50'
            ]])
                    }, [
                      _createElementVNode("div", _hoisted_327, [
                        _createElementVNode("div", _hoisted_328, [
                          _createVNode(_unref(UserPlus), { class: "w-4 h-4 text-emerald-600 dark:text-emerald-400" }),
                          _cache[146] || (_cache[146] = _createElementVNode("span", { class: "text-xs font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Staff Account Provisioning ", -1))
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2.5 py-0.5 rounded-full text-xs font-bold capitalize", (_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id) ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/60 dark:text-emerald-300' : 'bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300'])
                        }, _toDisplayString((_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id) ? 'Account Active' : 'Account Pending'), 3)
                      ]),
                      (_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
                            _cache[149] || (_cache[149] = _createElementVNode("p", null, " A staff portal account has been provisioned and linked to this application. ", -1)),
                            _createElementVNode("div", _hoisted_330, [
                              _createElementVNode("div", null, [
                                _cache[147] || (_cache[147] = _createElementVNode("span", { class: "text-gray-500" }, "Staff User ID:", -1)),
                                _createTextVNode(" #" + _toDisplayString(_ctx.application.fk_created_user_id || _ctx.application.fk_linked_user_id), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _cache[148] || (_cache[148] = _createElementVNode("span", { class: "text-gray-500" }, "Account Email:", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.application.created_user?.email || _ctx.application.email), 1)
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_331, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.application.record_type === 'paper' ? 'This paper record is not linked to any staff member. You can provision their staff portal account and email login credentials now.' : 'This candidate is approved. You can provision their staff portal account and email login credentials now.'), 1),
                            _createVNode(_unref(BaseButton), {
                              variant: "primary",
                              size: "sm",
                              text: "Create Staff Account Now",
                              icon: _unref(UserPlus),
                              "icon-position": "left",
                              class: "flex-shrink-0",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('create-account', _ctx.application)))
                            }, null, 8, ["icon"])
                          ]))
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.application.record_type !== 'paper')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_332, [
                      _createElementVNode("div", _hoisted_333, [
                        _createElementVNode("div", _hoisted_334, [
                          _createVNode(_unref(History), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
                          _cache[150] || (_cache[150] = _createElementVNode("span", null, "Applicant Secure Edit Access & Audit Trail", -1))
                        ]),
                        _createElementVNode("div", _hoisted_335, [
                          (_ctx.application.is_editable_by_applicant)
                            ? (_openBlock(), _createBlock(_unref(BaseButton), {
                                key: 0,
                                variant: "outline",
                                size: "sm",
                                text: "Resend Edit Link",
                                icon: _unref(Send),
                                "icon-position": "left",
                                loading: isResendingLink.value,
                                onClick: handleResendAccessLink
                              }, null, 8, ["icon", "loading"]))
                            : _createCommentVNode("", true),
                          (_ctx.application.has_active_access_link)
                            ? (_openBlock(), _createBlock(_unref(BaseButton), {
                                key: 1,
                                variant: "outline",
                                size: "sm",
                                text: "Revoke Access",
                                icon: _unref(KeyRound),
                                "icon-position": "left",
                                loading: isRevokingAccess.value,
                                class: "text-red-600 hover:text-red-700 border-red-200 hover:bg-red-50 dark:hover:bg-red-950/40",
                                onClick: handleRevokeAccess
                              }, null, 8, ["icon", "loading"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_336, [
                        _createElementVNode("div", _hoisted_337, [
                          _cache[151] || (_cache[151] = _createElementVNode("span", { class: "text-[10px] text-gray-400 uppercase font-semibold" }, "Edit Access Status", -1)),
                          _createElementVNode("p", _hoisted_338, _toDisplayString(_ctx.application.is_editable_by_applicant ? 'Active / Allowed' : 'Locked (Read-Only / Closed)'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_339, [
                          _cache[152] || (_cache[152] = _createElementVNode("span", { class: "text-[10px] text-gray-400 uppercase font-semibold" }, "Total Edits Saved", -1)),
                          _createElementVNode("p", _hoisted_340, _toDisplayString(_ctx.application.applicant_edit_count || 0) + " update session(s) ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_341, [
                          _cache[153] || (_cache[153] = _createElementVNode("span", { class: "text-[10px] text-gray-400 uppercase font-semibold" }, "Last Applicant Edit", -1)),
                          _createElementVNode("p", _hoisted_342, _toDisplayString(_ctx.application.last_edited_by_applicant_at ? formatDate(_ctx.application.last_edited_by_applicant_at) : 'No updates logged'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_343, [
                        _cache[155] || (_cache[155] = _createElementVNode("h4", { class: "text-xs font-bold text-gray-700 dark:text-gray-300 uppercase tracking-wide" }, " Modification History Log ", -1)),
                        (!_ctx.application.edit_logs || _ctx.application.edit_logs.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_344, " No applicant modification records logged yet. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_345, [
                              _createElementVNode("table", _hoisted_346, [
                                _cache[154] || (_cache[154] = _createElementVNode("thead", { class: "bg-gray-50 dark:bg-gray-900/60 text-[10px] uppercase font-bold text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700" }, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "p-3" }, "Date & Time"),
                                    _createElementVNode("th", { class: "p-3" }, "Modified Sections"),
                                    _createElementVNode("th", { class: "p-3" }, "IP Address")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", _hoisted_347, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.application.edit_logs, (log) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: log.edit_log_id,
                                      class: "hover:bg-gray-50/50 dark:hover:bg-gray-700/30"
                                    }, [
                                      _createElementVNode("td", _hoisted_348, _toDisplayString(formatDate(log.created_at)), 1),
                                      _createElementVNode("td", _hoisted_349, [
                                        _createElementVNode("div", _hoisted_350, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log.changed_sections, (section) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: section,
                                              class: "px-2 py-0.5 rounded text-[10px] font-semibold bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 uppercase"
                                            }, _toDisplayString(section.replace(/_/g, ' ')), 1))
                                          }), 128))
                                        ])
                                      ]),
                                      _createElementVNode("td", _hoisted_351, _toDisplayString(log.ip_address || '—'), 1)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, activeTab.value === 'review_history']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_352, [
              _createElementVNode("div", _hoisted_353, [
                _createElementVNode("div", _hoisted_354, [
                  _createVNode(_unref(Printer), { class: "w-5 h-5 text-secondary dark:text-secondary-dark-text" }),
                  _cache[156] || (_cache[156] = _createElementVNode("span", { class: "font-bold" }, "Official Application PDF & Print Document", -1))
                ]),
                _createElementVNode("div", _hoisted_355, [
                  (!isPaperRecord.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (isPrintSsnMasked.value = !isPrintSsnMasked.value)),
                        class: _normalizeClass(["inline-flex items-center px-3 py-1.5 text-xs font-semibold rounded-xl border transition-colors cursor-pointer", isPrintSsnMasked.value 
                ? 'bg-amber-50 text-amber-800 border-amber-300 hover:bg-amber-100 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800' 
                : 'bg-emerald-50 text-emerald-800 border-emerald-300 hover:bg-emerald-100 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800']),
                        title: isPrintSsnMasked.value ? 'SSN is masked with asterisks. Click to reveal full SSN.' : 'SSN is revealed. Click to mask SSN.'
                      }, [
                        (isPrintSsnMasked.value)
                          ? (_openBlock(), _createBlock(_unref(EyeOff), {
                              key: 0,
                              class: "w-3.5 h-3.5 mr-1.5 text-amber-600 dark:text-amber-400"
                            }))
                          : (_openBlock(), _createBlock(_unref(Eye), {
                              key: 1,
                              class: "w-3.5 h-3.5 mr-1.5 text-emerald-600 dark:text-emerald-400"
                            })),
                        _createTextVNode(" " + _toDisplayString(isPrintSsnMasked.value ? 'Print SSN: Masked' : 'Print SSN: Revealed'), 1)
                      ], 10, _hoisted_356))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BaseButton), {
                    variant: "outline",
                    size: "sm",
                    text: "Print Document",
                    icon: _unref(Printer),
                    "icon-position": "left",
                    onClick: handleRequestPrint
                  }, null, 8, ["icon"]),
                  _createVNode(_unref(BaseButton), {
                    variant: "outline",
                    size: "sm",
                    text: "Open PDF Tab",
                    icon: _unref(ExternalLink),
                    "icon-position": "left",
                    onClick: handleOpenPdfNewTab
                  }, null, 8, ["icon"])
                ])
              ]),
              _createElementVNode("div", _hoisted_357, [
                _createElementVNode("div", _hoisted_358, [
                  _createElementVNode("div", null, [
                    _cache[157] || (_cache[157] = _createElementVNode("h1", { class: "text-2xl font-black text-secondary uppercase tracking-tight" }, " Jeducare Services ", -1)),
                    _createElementVNode("p", _hoisted_359, _toDisplayString(isPaperRecord.value ? 'Official Digitized Employment Record' : 'Official Employment Application Record'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_360, [
                    _createElementVNode("p", _hoisted_361, "APPLICATION #" + _toDisplayString(_ctx.application.application_id), 1),
                    _createElementVNode("p", _hoisted_362, _toDisplayString(isPaperRecord.value ? 'Digitized: ' : 'Submitted: ') + _toDisplayString(formatDate(_ctx.application.submitted_at || _ctx.application.created_at)), 1),
                    _createElementVNode("div", _hoisted_363, [
                      _cache[158] || (_cache[158] = _createElementVNode("span", { class: "text-[11px] text-gray-500 font-medium leading-none" }, "Status:", -1)),
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2.5 py-0.5 rounded text-[10px] font-bold uppercase inline-flex items-center leading-normal", getStatusBadgeClass(_ctx.application.application_status)])
                      }, _toDisplayString(formatStatus(_ctx.application.application_status)), 3),
                      (isPaperRecord.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_364, " Paper Record "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                (isPaperRecord.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_365, [
                        _cache[164] || (_cache[164] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1 flex items-center space-x-1.5" }, [
                          _createElementVNode("span", null, "1. Applicant Profile & Contact")
                        ], -1)),
                        _createElementVNode("div", _hoisted_366, [
                          _createElementVNode("div", null, [
                            _cache[159] || (_cache[159] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Full Legal Name", -1)),
                            _createElementVNode("p", _hoisted_367, _toDisplayString(_ctx.application.full_name), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[160] || (_cache[160] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Email Address", -1)),
                            _createElementVNode("p", _hoisted_368, _toDisplayString(isPlaceholderEmail(_ctx.application.email) ? 'Not provided (Digitized Paper Record)' : (_ctx.application.email || 'Not provided')), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[161] || (_cache[161] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Phone Number", -1)),
                            _createElementVNode("p", _hoisted_369, _toDisplayString(_ctx.application.phone_number || 'Not provided'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_370, [
                            _cache[162] || (_cache[162] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Home / Street Address", -1)),
                            _createElementVNode("p", _hoisted_371, _toDisplayString(formatAddress(_ctx.application) || 'Not provided'), 1)
                          ]),
                          _cache[163] || (_cache[163] = _createElementVNode("div", null, [
                            _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Application Source"),
                            _createElementVNode("p", { class: "font-bold text-purple-700" }, "Offline / Paper Record (Digitized)")
                          ], -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_372, [
                        _cache[167] || (_cache[167] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1 flex items-center space-x-1.5" }, [
                          _createElementVNode("span", null, "2. Position & Target Availability")
                        ], -1)),
                        _createElementVNode("div", _hoisted_373, [
                          _createElementVNode("div", null, [
                            _cache[165] || (_cache[165] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Position Applied / Hired For", -1)),
                            _createElementVNode("p", _hoisted_374, _toDisplayString(_ctx.application.position_applied_for || 'Not specified'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[166] || (_cache[166] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Availability / Start Date", -1)),
                            _createElementVNode("p", _hoisted_375, _toDisplayString(_ctx.application.availability_date ? formatDate(_ctx.application.availability_date) : 'Not specified'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_376, [
                        _cache[168] || (_cache[168] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 3. Previous Experience Summary ", -1)),
                        _createElementVNode("div", _hoisted_377, [
                          _createElementVNode("p", _hoisted_378, _toDisplayString(_ctx.application.previous_experience || 'No previous experience summary was entered for this paper record.'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_379, [
                        _createElementVNode("h3", _hoisted_380, " 4. Attached Scanned Documents & Paperwork (" + _toDisplayString(localDocuments.value.length) + ") ", 1),
                        (!localDocuments.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_381, " No document attachments were uploaded. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_382, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localDocuments.value, (doc) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: doc.document_id,
                                  class: "p-2.5 flex items-center justify-between bg-white hover:bg-gray-50"
                                }, [
                                  _createElementVNode("div", _hoisted_383, [
                                    _createElementVNode("span", _hoisted_384, _toDisplayString(doc.file_name), 1),
                                    _createElementVNode("span", _hoisted_385, _toDisplayString(doc.document_category?.replace(/_/g, ' ') || 'paper record'), 1),
                                    _createElementVNode("span", _hoisted_386, _toDisplayString(formatFileSize(doc.file_size)), 1)
                                  ]),
                                  (doc.expiry_date)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_387, [
                                        _createElementVNode("span", _hoisted_388, " Exp: " + _toDisplayString(doc.expiry_date), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_389, [
                        _cache[174] || (_cache[174] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 5. Administrative Record & Remarks ", -1)),
                        _createElementVNode("div", _hoisted_390, [
                          _createElementVNode("div", null, [
                            _cache[169] || (_cache[169] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Record Status", -1)),
                            _createElementVNode("p", _hoisted_391, _toDisplayString(formatStatus(_ctx.application.application_status)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[170] || (_cache[170] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Digitized / Reviewed By", -1)),
                            _createElementVNode("p", _hoisted_392, _toDisplayString(_ctx.application.reviewer?.email || (_ctx.application.fk_reviewed_by ? `Admin #${_ctx.application.fk_reviewed_by}` : 'Admin')), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[171] || (_cache[171] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Record Date", -1)),
                            _createElementVNode("p", _hoisted_393, _toDisplayString(formatDate(_ctx.application.reviewed_at || _ctx.application.submitted_at || _ctx.application.created_at)), 1)
                          ]),
                          (_ctx.application.fk_linked_user_id || _ctx.application.fk_created_user_id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_394, [
                                _cache[172] || (_cache[172] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Linked Staff Account", -1)),
                                _createElementVNode("p", _hoisted_395, "Staff User #" + _toDisplayString(_ctx.application.fk_linked_user_id || _ctx.application.fk_created_user_id), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.application.admin_remarks)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_396, [
                                _cache[173] || (_cache[173] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Admin Remarks / Notes", -1)),
                                _createElementVNode("p", _hoisted_397, _toDisplayString(_ctx.application.admin_remarks), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_398, [
                        _cache[183] || (_cache[183] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1 flex items-center space-x-1.5" }, [
                          _createElementVNode("span", null, "1. Applicant Profile & Contact")
                        ], -1)),
                        _createElementVNode("div", _hoisted_399, [
                          _createElementVNode("div", null, [
                            _cache[175] || (_cache[175] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Full Legal Name", -1)),
                            _createElementVNode("p", _hoisted_400, _toDisplayString(_ctx.application.full_name), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[176] || (_cache[176] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Email Address", -1)),
                            _createElementVNode("p", _hoisted_401, _toDisplayString(_ctx.application.email), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[177] || (_cache[177] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Phone Number", -1)),
                            _createElementVNode("p", _hoisted_402, _toDisplayString(_ctx.application.phone_number || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_403, [
                            _cache[178] || (_cache[178] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Street Address", -1)),
                            _createElementVNode("p", _hoisted_404, _toDisplayString(_ctx.application.street_address) + ", " + _toDisplayString(_ctx.application.city) + ", " + _toDisplayString(_ctx.application.state) + " " + _toDisplayString(_ctx.application.zip_code), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[179] || (_cache[179] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Date of Birth", -1)),
                            _createElementVNode("p", _hoisted_405, _toDisplayString(jobApp.value?.date_of_birth || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[180] || (_cache[180] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Social Security Number", -1)),
                            _createElementVNode("p", _hoisted_406, _toDisplayString(isPrintSsnMasked.value ? maskSsn(applicantSsn.value) : (formatFullSsn(applicantSsn.value) || 'N/A')), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[181] || (_cache[181] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "NPI Number", -1)),
                            _createElementVNode("p", _hoisted_407, _toDisplayString(jobApp.value?.npi_number || 'None'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[182] || (_cache[182] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "US Work Authorization", -1)),
                            _createElementVNode("p", _hoisted_408, _toDisplayString(jobApp.value?.is_legally_eligible_to_work ? 'Yes (Authorized to work in US)' : 'No'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_409, [
                        _cache[197] || (_cache[197] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 2. Position Applied & Availability ", -1)),
                        _createElementVNode("div", _hoisted_410, [
                          _createElementVNode("div", null, [
                            _cache[184] || (_cache[184] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Position Applied", -1)),
                            _createElementVNode("p", _hoisted_411, _toDisplayString(_ctx.application.position_applied_for || 'General Application'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[185] || (_cache[185] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Employment Desired", -1)),
                            _createElementVNode("p", _hoisted_412, _toDisplayString(jobApp.value?.employment_desired || 'N/A'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[186] || (_cache[186] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Weekly Hours Available", -1)),
                            _createElementVNode("p", _hoisted_413, _toDisplayString(jobApp.value?.weekly_hours_available || 40) + " hrs/wk", 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[187] || (_cache[187] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Start Date", -1)),
                            _createElementVNode("p", _hoisted_414, _toDisplayString(_ctx.application.availability_date || jobApp.value?.date_available_for_work || 'Immediately'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[188] || (_cache[188] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Driver's License", -1)),
                            _createElementVNode("p", _hoisted_415, _toDisplayString(jobApp.value?.has_driver_license ? `Yes (${jobApp.value?.driver_license_state} #${jobApp.value?.driver_license_number || 'N/A'})` : 'No'), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[189] || (_cache[189] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Transportation", -1)),
                            _createElementVNode("p", _hoisted_416, _toDisplayString(jobApp.value?.transportation_means || 'Personal Vehicle'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_417, [
                          _createElementVNode("span", _hoisted_418, " Days & Hours Schedule " + _toDisplayString(jobApp.value?.availability_no_pref ? '(Open Availability)' : ''), 1),
                          _createElementVNode("div", _hoisted_419, [
                            _createElementVNode("div", _hoisted_420, [
                              _cache[190] || (_cache[190] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "MON", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_mon || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_421, [
                              _cache[191] || (_cache[191] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "TUE", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_tue || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_422, [
                              _cache[192] || (_cache[192] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "WED", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_wed || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_423, [
                              _cache[193] || (_cache[193] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "THU", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_thur || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_424, [
                              _cache[194] || (_cache[194] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "FRI", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_fri || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_425, [
                              _cache[195] || (_cache[195] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "SAT", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_sat || '—'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_426, [
                              _cache[196] || (_cache[196] = _createElementVNode("span", { class: "block text-[9px] text-gray-400 font-bold" }, "SUN", -1)),
                              _createTextVNode(_toDisplayString(jobApp.value?.available_sun || '—'), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_427, [
                        _cache[199] || (_cache[199] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 3. Education History ", -1)),
                        _createElementVNode("table", _hoisted_428, [
                          _cache[198] || (_cache[198] = _createElementVNode("thead", { class: "bg-gray-100 uppercase text-[10px] font-bold text-gray-600" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "p-2 border-r border-gray-200" }, "Level"),
                              _createElementVNode("th", { class: "p-2 border-r border-gray-200" }, "School Name"),
                              _createElementVNode("th", { class: "p-2 border-r border-gray-200" }, "Location"),
                              _createElementVNode("th", { class: "p-2 border-r border-gray-200" }, "Years"),
                              _createElementVNode("th", { class: "p-2" }, "Major / Degree")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", _hoisted_429, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobApp.value?.education_history || [], (edu, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", _hoisted_430, _toDisplayString(edu.type), 1),
                                _createElementVNode("td", _hoisted_431, _toDisplayString(edu.name_of_school || '—'), 1),
                                _createElementVNode("td", _hoisted_432, _toDisplayString(edu.location || '—'), 1),
                                _createElementVNode("td", _hoisted_433, _toDisplayString(edu.years_completed || '—'), 1),
                                _createElementVNode("td", _hoisted_434, _toDisplayString(edu.major_degree || '—'), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_435, [
                        _cache[201] || (_cache[201] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 4. Computer & Administrative Skills ", -1)),
                        _createElementVNode("div", _hoisted_436, [
                          _createElementVNode("div", _hoisted_437, [
                            (jobApp.value?.skill_windows)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_438, "✓ Windows OS"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_word)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_439, "✓ MS Word"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_excel)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_440, "✓ MS Excel"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_powerpoint)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_441, "✓ PowerPoint"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_access)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_442, "✓ MS Access"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_publisher)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_443, "✓ MS Publisher"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_typing)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_444, "✓ Fast Typing"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_wordperfect)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_445, "✓ WordPerfect"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_pc)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_446, "✓ PC"))
                              : _createCommentVNode("", true),
                            (jobApp.value?.skill_mac)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_447, "✓ Mac"))
                              : _createCommentVNode("", true)
                          ]),
                          (jobApp.value?.other_skills)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_448, [
                                _cache[200] || (_cache[200] = _createElementVNode("strong", null, "Other Skills / Certs:", -1)),
                                _createTextVNode(" " + _toDisplayString(jobApp.value.other_skills), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_449, [
                        _cache[207] || (_cache[207] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 5. Work Experience History ", -1)),
                        (!jobApp.value?.work_experiences?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_450, _toDisplayString(_ctx.application.previous_experience || 'No previous work experiences recorded.'), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_451, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobApp.value.work_experiences, (work, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: "p-3 rounded border border-gray-200 text-xs bg-gray-50/50 space-y-1"
                                }, [
                                  _createElementVNode("div", _hoisted_452, [
                                    _createElementVNode("span", null, _toDisplayString(work.name_of_employer || `Employer #${idx + 1}`), 1),
                                    _createElementVNode("span", _hoisted_453, _toDisplayString(work.from_date) + " — " + _toDisplayString(work.to_date || 'Present'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_454, [
                                    _createElementVNode("span", null, [
                                      _cache[202] || (_cache[202] = _createTextVNode("Title: ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(work.last_job_title || 'N/A'), 1)
                                    ]),
                                    _cache[205] || (_cache[205] = _createElementVNode("span", { class: "mx-2" }, "•", -1)),
                                    _createElementVNode("span", null, [
                                      _cache[203] || (_cache[203] = _createTextVNode("Supervisor: ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(work.last_supervisor || 'N/A'), 1)
                                    ]),
                                    _cache[206] || (_cache[206] = _createElementVNode("span", { class: "mx-2" }, "•", -1)),
                                    _createElementVNode("span", null, [
                                      _cache[204] || (_cache[204] = _createTextVNode("Phone: ", -1)),
                                      _createElementVNode("strong", null, _toDisplayString(work.phone_number || 'N/A'), 1)
                                    ])
                                  ]),
                                  (work.duties_skills_promotions)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_455, " Duties / Skills: " + _toDisplayString(work.duties_skills_promotions), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_456, [
                        _createElementVNode("div", _hoisted_457, [
                          _cache[208] || (_cache[208] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary" }, " 6. Employment References (3 References) ", -1)),
                          (displayReferences.value?.length)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["text-[10px] font-bold", verifiedReferencesCount.value === displayReferences.value.length ? 'text-emerald-700' : 'text-amber-700'])
                              }, _toDisplayString(verifiedReferencesCount.value) + " of " + _toDisplayString(displayReferences.value.length) + " Verified ", 3))
                            : _createCommentVNode("", true)
                        ]),
                        (!displayReferences.value?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_458, " No references recorded. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_459, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayReferences.value, (refItem, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: idx,
                                  class: _normalizeClass(["p-2.5 rounded border text-xs space-y-1", refItem.is_verified ? 'border-emerald-300 bg-emerald-50/40' : 'border-gray-200 bg-gray-50/50'])
                                }, [
                                  _createElementVNode("div", _hoisted_460, [
                                    _createElementVNode("span", _hoisted_461, _toDisplayString(refItem.name || `Reference #${idx + 1}`), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["px-1.5 py-0.2 rounded text-[9px] font-bold", refItem.is_verified ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-100 text-gray-600'])
                                    }, _toDisplayString(refItem.is_verified ? '✓ Verified' : 'Pending'), 3)
                                  ]),
                                  _createElementVNode("p", _hoisted_462, _toDisplayString(refItem.position_title) + " • " + _toDisplayString(refItem.organization), 1),
                                  _createElementVNode("p", _hoisted_463, "Phone: " + _toDisplayString(refItem.phone_number || 'N/A') + " | Email: " + _toDisplayString(refItem.email || 'N/A'), 1),
                                  (refItem.is_verified && refItem.verified_by)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_464, " Verified by " + _toDisplayString(refItem.verified_by), 1))
                                    : _createCommentVNode("", true),
                                  (refItem.verification_notes)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_465, " Note: " + _toDisplayString(refItem.verification_notes), 1))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_466, [
                        _cache[213] || (_cache[213] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 7. Background Check & Digital Waivers ", -1)),
                        _createElementVNode("div", _hoisted_467, [
                          _createElementVNode("div", _hoisted_468, [
                            _cache[209] || (_cache[209] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Background Check Acknowledged", -1)),
                            _createElementVNode("p", _hoisted_469, _toDisplayString(_ctx.application.background_check_data?.acknowledges_requirements ? '✓ Confirmed & Accepted Requirements' : '✗ Not Acknowledged'), 1),
                            _createElementVNode("p", _hoisted_470, "Signed: " + _toDisplayString(_ctx.application.background_check_data?.applicant_name || _ctx.application.full_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_471, [
                            _cache[210] || (_cache[210] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Criminal History Disclosure", -1)),
                            _createElementVNode("p", {
                              class: _normalizeClass(["font-bold mt-0.5", jobApp.value?.has_been_convicted_of_crime ? 'text-red-600' : 'text-gray-900'])
                            }, _toDisplayString(jobApp.value?.has_been_convicted_of_crime ? 'Yes - Conviction Disclosed' : 'No criminal convictions disclosed'), 3),
                            (jobApp.value?.crime_conviction_explanation)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_472, _toDisplayString(jobApp.value.crime_conviction_explanation), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_473, [
                            _cache[211] || (_cache[211] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Application Waiver Signature", -1)),
                            _createElementVNode("p", _hoisted_474, _toDisplayString(jobApp.value?.waiver_signature || 'N/A'), 1),
                            _createElementVNode("p", _hoisted_475, "Date: " + _toDisplayString(jobApp.value?.waiver_date), 1)
                          ]),
                          _createElementVNode("div", _hoisted_476, [
                            _cache[212] || (_cache[212] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Job Description Signature", -1)),
                            _createElementVNode("p", _hoisted_477, _toDisplayString(jobApp.value?.job_description_signature || 'N/A'), 1),
                            _createElementVNode("p", _hoisted_478, "Date: " + _toDisplayString(jobApp.value?.job_description_date), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_479, [
                        _cache[240] || (_cache[240] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 8. Complete Tax Declarations & Documentation (MW507, I-9, W-4) ", -1)),
                        _createElementVNode("div", _hoisted_480, [
                          _createElementVNode("div", _hoisted_481, [
                            _cache[214] || (_cache[214] = _createElementVNode("span", null, "Maryland Form MW507 (State Withholding Exemption)", -1)),
                            _createElementVNode("span", _hoisted_482, "Signed: " + _toDisplayString(taxDocs.value?.mw507?.employee_signature || 'N/A') + " (" + _toDisplayString(taxDocs.value?.mw507?.signature_date || 'N/A') + ")", 1)
                          ]),
                          _createElementVNode("div", _hoisted_483, [
                            _createElementVNode("div", null, [
                              _cache[215] || (_cache[215] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Name / SSN:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.mw507?.full_name || _ctx.application.full_name), 1),
                              _createElementVNode("span", _hoisted_484, " SSN: " + _toDisplayString(isPrintSsnMasked.value ? maskSsn(taxDocs.value?.mw507?.social_security_number || applicantSsn.value) : (formatFullSsn(taxDocs.value?.mw507?.social_security_number || applicantSsn.value) || 'N/A')), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[216] || (_cache[216] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Filing Status:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.mw507?.filing_status || 'Single'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[217] || (_cache[217] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "County:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.mw507?.county_of_residence || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[218] || (_cache[218] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Line 1 Exemptions:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.mw507?.line1_total_exemptions ?? '1'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[219] || (_cache[219] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Line 2 Addl Withholding:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.mw507?.line2_additional_withholding || '0'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[220] || (_cache[220] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Line 3 Exemption:", -1)),
                              _createElementVNode("strong", null, _toDisplayString((taxDocs.value?.mw507?.line3_a_last_year_no_tax || taxDocs.value?.mw507?.line3_b_this_year_no_tax) ? 'Yes (Claimed)' : 'None'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_485, [
                              _cache[221] || (_cache[221] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Reciprocity / Military Spouse State:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.mw507?.line4_domiciled_state || taxDocs.value?.mw507?.line8_military_spouse_state || 'MD Resident'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_486, [
                          _createElementVNode("div", _hoisted_487, [
                            _cache[222] || (_cache[222] = _createElementVNode("span", null, "USCIS Form I-9 (Employment Eligibility Verification)", -1)),
                            _createElementVNode("span", _hoisted_488, "Signed: " + _toDisplayString(taxDocs.value?.i9?.employee_signature || 'N/A') + " (" + _toDisplayString(taxDocs.value?.i9?.signature_date || 'N/A') + ")", 1)
                          ]),
                          _createElementVNode("div", _hoisted_489, [
                            _createElementVNode("div", null, [
                              _cache[223] || (_cache[223] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Employee Name:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.first_name) + " " + _toDisplayString(taxDocs.value?.i9?.middle_initial ? taxDocs.value?.i9?.middle_initial + '.' : '') + " " + _toDisplayString(taxDocs.value?.i9?.last_name), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[224] || (_cache[224] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Other Names:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.other_last_names || 'None'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[225] || (_cache[225] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Date of Birth:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.date_of_birth || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[226] || (_cache[226] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Telephone:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.telephone_number || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_490, [
                              _cache[227] || (_cache[227] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Citizenship Status:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.citizenship_status ? taxDocs.value?.i9?.citizenship_status.replace(/_/g, ' ').toUpperCase() : 'CITIZEN'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[228] || (_cache[228] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Alien / USCIS #:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.alien_registration_number || taxDocs.value?.i9?.work_auth_doc_number || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[229] || (_cache[229] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Work Auth Expiration:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.i9?.alien_authorized_expiration_date || 'N/A (No Expiration)'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_491, [
                          _createElementVNode("div", _hoisted_492, [
                            _cache[230] || (_cache[230] = _createElementVNode("span", null, "IRS Form W-4 (Federal Income Tax Withholding)", -1)),
                            _createElementVNode("span", _hoisted_493, "Signed: " + _toDisplayString(taxDocs.value?.w4?.employee_signature || 'N/A') + " (" + _toDisplayString(taxDocs.value?.w4?.signature_date || 'N/A') + ")", 1)
                          ]),
                          _createElementVNode("div", _hoisted_494, [
                            _createElementVNode("div", null, [
                              _cache[231] || (_cache[231] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Name on W-4:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.w4?.first_name_middle_initial) + " " + _toDisplayString(taxDocs.value?.w4?.last_name), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[232] || (_cache[232] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Federal Filing Status:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.w4?.filing_status || 'Single'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[233] || (_cache[233] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 2 Multiple Jobs:", -1)),
                              _createElementVNode("strong", null, _toDisplayString(taxDocs.value?.w4?.step2_multiple_jobs_or_spouse_works ? 'Yes (Checked)' : 'No'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[234] || (_cache[234] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 3 Total Dependents:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step3_total_dependent_amount || '0.00'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[235] || (_cache[235] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 3 Qualifying Children:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step3_qualifying_children_amount || '0.00'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[236] || (_cache[236] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 3 Other Dependents:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step3_other_dependents_amount || '0.00'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[237] || (_cache[237] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 4(a) Other Income:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step4a_other_income_amount || '0.00'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[238] || (_cache[238] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 4(b) Deductions:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step4b_deductions_amount || '0.00'), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[239] || (_cache[239] = _createElementVNode("span", { class: "text-gray-400 block text-[10px]" }, "Step 4(c) Extra Withholding:", -1)),
                              _createElementVNode("strong", null, "$" + _toDisplayString(taxDocs.value?.w4?.step4c_extra_withholding_amount || '0.00'), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_495, [
                        _createElementVNode("h3", _hoisted_496, " 9. Attached Documents (" + _toDisplayString(localDocuments.value.length) + ") ", 1),
                        (!localDocuments.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_497, " No attachments uploaded with this application. "))
                          : (_openBlock(), _createElementBlock("div", _hoisted_498, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localDocuments.value, (doc) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: doc.document_id,
                                  class: "p-2.5 rounded border border-gray-200 bg-gray-50/50 flex items-center justify-between"
                                }, [
                                  _createElementVNode("div", _hoisted_499, [
                                    _createElementVNode("span", _hoisted_500, _toDisplayString(doc.file_name), 1),
                                    _createElementVNode("span", _hoisted_501, _toDisplayString(doc.document_category || 'general') + " • " + _toDisplayString(formatFileSize(doc.file_size)), 1)
                                  ]),
                                  (doc.expiry_date)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_502, [
                                        _createElementVNode("span", _hoisted_503, " Exp: " + _toDisplayString(doc.expiry_date), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_504, [
                        _cache[245] || (_cache[245] = _createElementVNode("h3", { class: "text-xs font-bold uppercase tracking-wider text-secondary border-b border-gray-200 pb-1" }, " 10. Administrative Review & Status ", -1)),
                        _createElementVNode("div", _hoisted_505, [
                          _createElementVNode("div", null, [
                            _cache[241] || (_cache[241] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Decision Status", -1)),
                            _createElementVNode("p", _hoisted_506, _toDisplayString(formatStatus(_ctx.application.application_status)), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[242] || (_cache[242] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Reviewed By", -1)),
                            _createElementVNode("p", _hoisted_507, _toDisplayString(_ctx.application.reviewer?.email || (_ctx.application.fk_reviewed_by ? `Admin #${_ctx.application.fk_reviewed_by}` : 'Pending')), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[243] || (_cache[243] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Decision Date", -1)),
                            _createElementVNode("p", _hoisted_508, _toDisplayString(_ctx.application.reviewed_at ? formatDate(_ctx.application.reviewed_at) : 'Not reviewed yet'), 1)
                          ]),
                          (_ctx.application.admin_remarks)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_509, [
                                _cache[244] || (_cache[244] = _createElementVNode("span", { class: "text-[10px] text-gray-500 uppercase font-semibold" }, "Admin Remarks", -1)),
                                _createElementVNode("p", _hoisted_510, _toDisplayString(_ctx.application.admin_remarks), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64)),
                _createElementVNode("div", _hoisted_511, " Jeducare Portal • Application Ref #" + _toDisplayString(_ctx.application.application_id) + " • Confidential Document ", 1)
              ])
            ], 512), [
              [_vShow, activeTab.value === 'print_pdf']
            ])
          ])),
      _createVNode(PrintConfirmModal, {
        "is-visible": isPrintConfirmVisible.value,
        application: _ctx.application,
        "initial-mask-ssn": isPrintSsnMasked.value,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (isPrintConfirmVisible.value = false)),
        onConfirm: handleConfirmPrint
      }, null, 8, ["is-visible", "application", "initial-mask-ssn"]),
      _createVNode(ViewApplicationDocumentModal, {
        "is-visible": isPreviewModalVisible.value,
        document: selectedDocForPreview.value,
        onClose: _cache[14] || (_cache[14] = ($event: any) => (isPreviewModalVisible.value = false))
      }, null, 8, ["is-visible", "document"]),
      _createVNode(_unref(BaseModal), {
        "is-visible": isUploadModalOpen.value,
        title: "Upload Additional Documents",
        subtitle: "Attach scanned paperwork, certificates, or IDs to this application record.",
        icon: _unref(UploadCloud),
        size: "lg",
        "show-footer": true,
        onClose: closeUploadModal
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_522, [
            _createVNode(_unref(BaseButton), {
              variant: "outline",
              size: "md",
              text: "Cancel",
              disabled: isUploadingDocs.value,
              onClick: closeUploadModal
            }, null, 8, ["disabled"]),
            _createVNode(_unref(BaseButton), {
              variant: "success",
              size: "md",
              text: isUploadingDocs.value ? 'Uploading...' : (newUploadFiles.value.length > 0 ? `Upload ${newUploadFiles.value.length} Document${newUploadFiles.value.length === 1 ? '' : 's'}` : 'Upload Documents'),
              loading: isUploadingDocs.value,
              disabled: newUploadFiles.value.length === 0 || isUploadingDocs.value,
              icon: _unref(UploadCloud),
              "icon-position": "left",
              onClick: handleExecuteUploadDocs
            }, null, 8, ["text", "loading", "disabled", "icon"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_514, [
            _createElementVNode("div", {
              class: _normalizeClass(["border-2 border-dashed rounded-2xl p-6 text-center cursor-pointer transition-colors", isDragging.value ? 'border-secondary bg-secondary/5' : 'border-gray-300 dark:border-gray-600 hover:border-secondary/60']),
              onDragover: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (isDragging.value = true), ["prevent"])),
              onDragleave: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (isDragging.value = false), ["prevent"])),
              onDrop: _withModifiers(handleExtraFileDrop, ["prevent"]),
              onClick: triggerExtraFileInput
            }, [
              _createElementVNode("input", {
                ref_key: "extraFileInputRef",
                ref: extraFileInputRef,
                type: "file",
                multiple: "",
                accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
                class: "hidden",
                onChange: handleExtraFileInputChange
              }, null, 544),
              _createVNode(_unref(UploadCloud), { class: "w-10 h-10 text-gray-400 mx-auto mb-2" }),
              _cache[246] || (_cache[246] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 dark:text-gray-200" }, " Click to select files or drag and drop here ", -1)),
              _cache[247] || (_cache[247] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 mt-1" }, " Supported formats: PDF, DOC, DOCX, JPG, PNG (Max 32MB per file) ", -1))
            ], 34),
            (newUploadFiles.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_515, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newUploadFiles.value, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "p-3 rounded-xl bg-gray-50 dark:bg-gray-800/80 border border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs"
                    }, [
                      _createElementVNode("div", _hoisted_516, [
                        _createElementVNode("p", _hoisted_517, _toDisplayString(item.file.name), 1),
                        _createElementVNode("p", _hoisted_518, _toDisplayString(formatFileSize(item.file.size)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_519, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((item.category) = $event),
                          class: "px-2.5 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-xs"
                        }, [...(_cache[248] || (_cache[248] = [
                          _createElementVNode("option", { value: "job_application" }, "Job Application", -1),
                          _createElementVNode("option", { value: "background_check" }, "Background Check", -1),
                          _createElementVNode("option", { value: "tax_mw507" }, "Tax (MW507)", -1),
                          _createElementVNode("option", { value: "tax_i9" }, "Tax (I-9)", -1),
                          _createElementVNode("option", { value: "tax_w4" }, "Tax (W-4)", -1),
                          _createElementVNode("option", { value: "identification" }, "Identification", -1),
                          _createElementVNode("option", { value: "certification" }, "Certification", -1),
                          _createElementVNode("option", { value: "resume" }, "Resume / CV", -1),
                          _createElementVNode("option", { value: "other" }, "Other Document", -1)
                        ]))], 8, _hoisted_520), [
                          [_vModelSelect, item.category]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "p-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-950/40 rounded-lg transition cursor-pointer",
                          title: "Remove file",
                          onClick: ($event: any) => (newUploadFiles.value.splice(idx, 1))
                        }, [
                          _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                        ], 8, _hoisted_521)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["is-visible", "icon"])
    ]),
    _: 1
  }, 8, ["is-visible", "title", "subtitle", "icon"]))
}
}

})